<div id="toolbar" class="main-menu menu-fixed menu-light menu-accordion menu-shadow" data-scroll-to-active="true">
  <div class="navbar-header">
    <ul class="nav navbar-nav flex-row">
      <li class="nav-item mr-auto">
        <div class="navbar-brand">
          <img src="assets/images/logo.svg" width="160" alt="vittoria">
        </div>
      </li>
    </ul>
  </div>
  <div class="shadow-bottom"></div>
  <div class="main-menu-content">
    <ul class="navigation navigation-main" id="main-menu-navigation" data-menu="menu-navigation">
      <li class="nav-item {{menuToolbar['adm']['index']}}">
        <a class="d-flex align-items-center" [routerLink]="['/admin/management']" data-toggle="tooltip"
           data-placement="auto" title="Inicio">
          <i data-feather="home"></i>
          <span class="menu-title text-truncate" title="Inicio" data-i18n="Dashboards">Inicio</span>
        </a>
      </li>
      <li class="navigation-header" style="color: #fbd304"
          *ngIf="usuario.usuario.idRol !== 80 && usuario.usuario.idRol !== 84 && usuario.usuario.idRol !== 87 && usuario.usuario.idRol !== 84 && usuario.usuario.idRol !== 87 && (acciones.ADM.LEER || usuario.usuario.idRol !== 86)">
        Administración
      </li>
      <li class="nav-item has-sub ng-star-inserted" *ngIf="acciones.ADM.LEER">
        <a class="d-flex align-items-center" title="Parametrizaciones">
          <i data-feather="circle"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">Parametrizaciones</span></a>
        <ul class="menu-content ng-star-inserted">
          <li class="nav-item {{menuToolbar['adm']['param']}}"
              *ngIf="acciones.ADM.LEER && usuario.usuario.idRol !== 86">
            <a class="d-flex align-items-center" [routerLink]="['/admin/param']" data-toggle="tooltip"
               data-placement="auto" title="Parametrizaciones Generales de administración">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate"
                    data-i18n="List">Parametrizaciones Generales de administración</span></a>
          </li>
          <li class="nav-item" *ngIf="acciones.ADM.LEER && usuario.usuario.idRol !== 86">
            <a class="d-flex align-items-center" [routerLink]="['/admin/configuracion-login']" data-toggle="tooltip"
               data-placement="auto" title="Personalización de LOGIN">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Personalización de LOGIN</span></a>
          </li>
          <li class="nav-item" *ngIf="acciones.ADM.LEER && usuario.usuario.idRol !== 86">
            <a class="d-flex align-items-center" [routerLink]="['/admin/parametrizaciones-marketplace']"
               data-toggle="tooltip"
               data-placement="auto" title="Parametrizaciones del Marketplace">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Parametrizaciones Marketplace</span></a>
          </li>
          <li class="nav-item" *ngIf="acciones.ADM.LEER">
            <a class="d-flex align-items-center" [routerLink]="['/admin/params/premios-publicaciones']"
               data-toggle="tooltip"
               data-placement="auto" title="Parametrizaciones de premios por publicaciones">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate"
                    data-i18n="List">Parametrizaciones de premios por publicaciones</span></a>
          </li>
          <li class="nav-item" *ngIf="usuario.usuario.idRol !== 86">
            <a class="d-flex align-items-center" [routerLink]="['mdrp/productos/params/tarifa_logistica']"
               data-toggle="tooltip"
               data-placement="auto" title="Tarifa de gestión de logística de producto">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate"
                    data-i18n="List">Tarifa de gestión de logística de producto</span></a>
          </li>
          <li class="nav-item" *ngIf="acciones.ADM.LEER">
            <a class="d-flex align-items-center" [routerLink]="['/admin/parametrizaciones-marketing-pixels']"
               data-toggle="tooltip"
               data-placement="auto" title="Pixels">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Pixels</span></a>
          </li>
        </ul>
      </li>
      <li class="nav-item has-sub ng-star-inserted" *ngIf="acciones.ADM.LEER && usuario.usuario.idRol !== 86">
        <a class="d-flex align-items-center" title="Administración COAC">
          <i data-feather="circle"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">Administración COAC</span></a>
        <ul class="menu-content ng-star-inserted">
          <li class="nav-item" *ngIf="acciones.ADM.LEER">
            <a class="d-flex align-items-center" [routerLink]="['/admin/parametrizaciones-coac']" data-toggle="tooltip"
               data-placement="auto" title="Parametrizaciones COAC">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Parametrizaciones COAC</span></a>
          </li>
          <li class="nav-item" *ngIf="acciones.ADM.LEER">
            <a class="d-flex align-items-center" [routerLink]="['/admin/calculo-cuotas-coac']" data-toggle="tooltip"
               data-placement="auto" title="Cálculo de cuotas COAC">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Cálculo de cuotas COAC</span></a>
          </li>
        </ul>
      </li>
      <li class="nav-item has-sub ng-star-inserted" *ngIf="acciones.ADM.LEER && usuario.usuario.idRol !== 86">
        <a class="d-flex align-items-center" title="Administración Cuotas Tarjeta">
          <i data-feather="circle"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">Administración Cuotas Tarjeta</span></a>
        <ul class="menu-content ng-star-inserted">
          <li class="nav-item" *ngIf="acciones.ADM.LEER">
            <a class="d-flex align-items-center" [routerLink]="['/admin/parametrizaciones-cuotas-tarjeta']"
               data-toggle="tooltip"
               data-placement="auto" title="Parametrizaciones Cuotas Tarjeta">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Parametrizaciones Cuotas Tarjeta</span></a>
          </li>
          <li class="nav-item" *ngIf="acciones.ADM.LEER">
            <a class="d-flex align-items-center" [routerLink]="['/admin/calculo-cuotas-tarjeta']" data-toggle="tooltip"
               data-placement="auto" title="Cálculo de cuotas Cuotas Tarjeta">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Cálculo de cuotas Cuotas Tarjeta</span></a>
          </li>
        </ul>
      </li>
      <li class="nav-item has-sub ng-star-inserted" *ngIf="acciones.ADM.LEER && usuario.usuario.idRol !== 86">
        <a class="d-flex align-items-center" title="Accesos">
          <i data-feather="circle"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">Accesos</span></a>
        <ul class="menu-content ng-star-inserted">
          <li class="nav-item {{menuToolbar['adm']['user']}}">
            <a class="d-flex align-items-center" [routerLink]="['/admin/user']" data-toggle="tooltip"
               data-placement="auto" title="Creación de los usuario del sistema">
              <i data-feather="user"></i>
              <span class="menu-title text-truncate" data-i18n="User">Usuarios</span>
            </a>
          </li>
          <li class="nav-item {{menuToolbar['adm']['roles']}}">
            <a class="d-flex align-items-center" [routerLink]="['/admin/roles']" data-toggle="tooltip"
               data-placement="auto" title="Creación de los roles del sistema">
              <i data-feather="check-square"></i>
              <span class="menu-title text-truncate" data-i18n="Todo">Rol de usuarios</span></a>
          </li>
        </ul>
      </li>
      <li class="nav-item has-sub ng-star-inserted" *ngIf="acciones.ADM.LEER && usuario.usuario.idRol !== 86">
        <a class="d-flex align-items-center" title="Integraciones">
          <i data-feather="circle"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">Integraciones</span></a>
        <ul class="menu-content ng-star-inserted">
          <li class="nav-item {{menuToolbar['adm']['integracionesWoocommerce']}}">
            <a class="d-flex align-items-center" [routerLink]="['/admin/integraciones-woocommerce']"
               data-toggle="tooltip"
               data-placement="auto" title="Integraciones Canales">
              <i data-feather="home"></i>
              <span class="menu-item text-truncate" data-i18n="List">Integraciones Canales</span></a>
          </li>
          <li class="nav-item {{menuToolbar['adm']['integracionesWoocommerce']}}">
            <a class="d-flex align-items-center" [routerLink]="['/admin/integraciones-inactivas']" data-toggle="tooltip"
               data-placement="auto" title="Canales Inactivos/Eliminados">
              <i data-feather="home"></i>
              <span class="menu-item text-truncate" data-i18n="List">Canales Inactivos/Eliminados</span></a>
          </li>
          <li class="nav-item {{menuToolbar['adm']['integracionesWoocommerce']}}">
            <a class="d-flex align-items-center" [routerLink]="['/admin/integraciones-woocommerce/predeterminado']"
               data-toggle="tooltip"
               data-placement="auto" title="Canales predeterminados">
              <i data-feather="home"></i>
              <span class="menu-item text-truncate" data-i18n="List">Canales predeterminados</span></a>
          </li>
          <li class="nav-item {{menuToolbar['adm']['integracionesEnvio']}}">
            <a class="d-flex align-items-center" [routerLink]="['/admin/integraciones-envio']" data-toggle="tooltip"
               data-placement="auto" title="Integraciones Envio">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Integraciones Envio</span></a>
          </li>
        </ul>
      </li>
      <li class="nav-item {{menuToolbar['adm']['monitoreoPedidos']}}"
          *ngIf="acciones.ADM.LEER && usuario.usuario.idRol !== 86">
        <a class="d-flex align-items-center" [routerLink]="['/admin/monitoreo/pedidos']" data-toggle="tooltip"
           data-placement="auto" title="Monitoreo de Pedidos">
          <i data-feather="circle"></i>
          <span class="menu-item text-truncate" data-i18n="List">Monitoreo de Pedidos</span></a>
      </li>
      <li class="nav-item" *ngIf="acciones.ADM.LEER && usuario.usuario.idRol !== 86">
        <a class="d-flex align-items-center" [routerLink]="['/mdm/influencers']" data-toggle="tooltip"
           data-placement="auto" title="Configuración de influencers">
          <i data-feather="circle"></i>
          <span class="menu-item text-truncate" data-i18n="List">Configuración de influencers</span></a>
      </li>
      <li class="navigation-header" style="color: #fbd304">Módulos de sistema</li>
      <li class="navigation-header"
          *ngIf="usuario.usuario.idRol !== 80 && usuario.usuario.idRol !== 84 && usuario.usuario.idRol !== 87 && usuario.usuario.idRol !== 84 && usuario.usuario.idRol !== 87 && (acciones.MDDAC.LEER || acciones.MDRP.LEER || (acciones.MDP.LEER && (usuario.usuario.idRol !== 85 && usuario.usuario.idRol !== 86 || usuario.usuario.idRol !== 85 || usuario.usuario.idRol !== 68)) || acciones.PPE.LEER)">
        ADMINISTRACION PRODUCTOS
      </li>
      <li class="nav-item" *ngIf="acciones.MDDAC.LEER">
        <a class="d-flex align-items-center" title="MDDAC Motor Directo al Consumidor">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">MDDAC Motor Directo al Consumidor</span></a>
        <ul class="menu-content ng-star-inserted">
          <li class="nav-item">
            <a class="d-flex align-items-center" [routerLink]="['mddac/parametrizaciones/lista']" data-toggle="tooltip"
               data-placement="auto" title="Parametrizaciones">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Parametrización</span></a>
          </li>
          <li class="nav-item has-sub ng-star-inserted"
              *ngIf="usuario.usuario.idRol !== 59 && usuario.usuario.idRol !== 60 && usuario.usuario.idRol !== 67 && usuario.usuario.idRol !== 68 && usuario.usuario.idRol !== 69 && usuario.usuario.idRol !== 72 && usuario.usuario.idRol !== 73 && usuario.usuario.idRol !== 77 && usuario.usuario.idRol !== 78">
            <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
               title="Administración de proveedores">
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Administración de proveedores</span></a>
            <ul class="menu-content">
              <li class="nav-item {{menuToolbar['mdp']['param']}}">
                <a class="d-flex align-items-center" [routerLink]="['mdp/proveedores']"
                   data-toggle="tooltip"
                   data-placement="auto" title="Gestión proveedores">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Gestión proveedores</span></a>
              </li>
              <li class="nav-item {{menuToolbar['mdp']['param']}}">
                <a class="d-flex align-items-center" href="#/mdp/gestion-proveedores/cargar-productos"
                   data-toggle="tooltip"
                   data-placement="auto" title="Cargar Proveedores">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Cargar</span></a>
              </li>
              <li class="nav-item {{menuToolbar['mdp']['param']}}">
                <a class="d-flex align-items-center" href="#/mdp/gestion-proveedores/buscar-productos"
                   data-toggle="tooltip"
                   data-placement="auto" title="Buscar Proveedores">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Buscar</span></a>
              </li>

            </ul>
          </li>
          <li class="nav-item has-sub ng-star-inserted">
            <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
               title="Administración de productos para distribución">
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Administración de productos para distribución</span></a>
            <ul class="menu-content">
              <li class="nav-item">
                <a class="d-flex align-items-center" [routerLink]="['mddac/productos/lista']" data-toggle="tooltip"
                   data-placement="auto" title="Listado de Productos">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Listado de productos</span></a>
              </li>
            </ul>
          </li>
          <li class="nav-item has-sub=">
            <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
               title="Administración de distribución">
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Administración de distribución</span></a>
            <ul class="menu-content">
              <li class="nav-item">
                <a class="d-flex align-items-center" [routerLink]="['mddac/punto-distribucion/enviar']"
                   data-toggle="tooltip"
                   data-placement="auto" title="Enviar Productos a Puntos de Distribución (PE Córners)">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Enviar productos a Puntos de Distribución (PE Córners)</span></a>
              </li>
              <li class="nav-item">
                <a class="d-flex align-items-center" [routerLink]="['mddac/punto-distribucion/confirmar']"
                   data-toggle="tooltip"
                   data-placement="auto" title="Confirmar Envío a Puntos de Distribución (PE Córners)">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Confirmar Envío a Puntos de Distribución (PE Córners)</span></a>
              </li>
              <li class="nav-item">
                <a class="d-flex align-items-center" [routerLink]="['mddac/punto-distribucion/lista/envios']"
                   data-toggle="tooltip"
                   data-placement="auto" title="Reporte de Envíos a Puntos de Distribución">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Reporte de Envíos a Puntos de Distribución</span></a>
              </li>
            </ul>
          </li>
          <li class="nav-item has-sub ng-star-inserted">
            <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
               title="Administración de Ventas">
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Administración de Ventas</span></a>
            <ul class="menu-content">
              <li class="nav-item">
                <a class="d-flex align-items-center" [routerLink]="['mddac/mis-ventas/por-envios']"
                   data-toggle="tooltip"
                   data-placement="auto" title="Reporte por envíos">
                  <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                     data-i18n="List">Reporte por envíos</span></a>
              </li>
              <li class="nav-item">
                <a class="d-flex align-items-center" [routerLink]="['mddac/mis-ventas/por-productos']"
                   data-toggle="tooltip"
                   data-placement="auto" title="Reporte por productos">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Reporte por productos</span></a>
              </li>
            </ul>
          </li>

          <li class="nav-item has-sub ng-star-inserted">
            <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
               title="Administración de costos">
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Administración de costos</span></a>
            <ul class="menu-content">
              <li class="nav-item">
                <a class="d-flex align-items-center" [routerLink]="['mddac/costos/mis-cobros']" data-toggle="tooltip"
                   data-placement="auto" title="Mis Cobros">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Mis Cobros</span></a>
              </li>
              <li class="nav-item">
                <a class="d-flex align-items-center" [routerLink]="['mddac/costos/mis-pagos']" data-toggle="tooltip"
                   data-placement="auto" title="Mis Pagos">
                  <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                     data-i18n="List">Mis Pagos</span></a>
              </li>
            </ul>
          </li>
        </ul>
      </li>
      <li class="nav-item" *ngIf="acciones.MDRP.LEER">
        <a class="d-flex align-items-center" title="MDRP Motor de recepción de productos">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">MDRP Motor de recepción de productos</span></a>
        <ul class="menu-content ng-star-inserted">
          <li class="nav-item has-sub ng-star-inserted" *ngIf="usuario.usuario.idRol === 1">
            <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
               title="Parametrizaciones">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Parametrizaciones</span></a>
            <ul class="menu-content">

            </ul>
          </li>
          <li class="nav-item">
            <a class="d-flex align-items-center" [routerLink]="['mdrp/productos/recepcion']" data-toggle="tooltip"
               data-placement="auto" title="Recepción de productos">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Recepción de productos</span></a>
          </li>
          <li class="nav-item">
            <a class="d-flex align-items-center" [routerLink]="['mdrp/productos/confirmacion/recepcion']"
               data-toggle="tooltip"
               data-placement="auto" title="Confirmación recepción de productos">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Confirmación recepción de productos</span></a>
          </li>
          <li class="nav-item"
              *ngIf="usuario.usuario.idRol !== 66 && usuario.usuario.idRol !== 69 && usuario.usuario.idRol !== 72">
            <a class="d-flex align-items-center" [routerLink]="['mdrp/productos/generacion/comprobante']"
               data-toggle="tooltip"
               data-placement="auto" title="Generar Comprobante de Recepción">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Generar Comprobante de Recepción</span></a>
          </li>
          <li class="nav-item"
              *ngIf="usuario.usuario.idRol !== 66 && usuario.usuario.idRol !== 69 && usuario.usuario.idRol !== 72">
            <a class="d-flex align-items-center" [routerLink]="['mdrp/productos/aprobacion']" data-toggle="tooltip"
               data-placement="auto" title="Aprobación recepción de productos">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Aprobación recepción de productos</span></a>
          </li>
          <li class="nav-item"
              *ngIf="usuario.usuario.idRol !== 66 && usuario.usuario.idRol !== 69 && usuario.usuario.idRol !== 72">
            <a class="d-flex align-items-center" [routerLink]="['mdrp/productos/list']" data-toggle="tooltip"
               data-placement="auto" title="Listado de recepción de productos">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Listado de recepción de productos</span></a>
          </li>
          <li class="nav-item" *ngIf="usuario.usuario.idRol === 1">
            <a class="d-flex align-items-center" [routerLink]="['mdrp/productos/reporte']" data-toggle="tooltip"
               data-placement="auto" title="Reporte de recepción de productos">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Reporte de recepción de productos</span></a>
          </li>
        </ul>
      </li>
      <li class="nav-item" *ngIf="acciones.MDP.LEER">
        <a class="d-flex align-items-center" title="MDP Master Data Products">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">MDP Master Data Products</span></a>
        <ul class="menu-content ng-star-inserted">
          <li class="nav-item {{menuToolbar['mdp']['param']}}"
              *ngIf="usuario.usuario.idRol !== 60 && usuario.usuario.idRol !== 59 && usuario.usuario.idRol !== 67 && usuario.usuario.idRol !== 68 && usuario.usuario.idRol !== 69 && usuario.usuario.idRol !== 72 && usuario.usuario.idRol !== 73 && usuario.usuario.idRol !== 77 && usuario.usuario.idRol !== 78 && usuario.usuario.idRol !== 85 && usuario.usuario.idRol !== 86 && usuario.usuario.idRol !== 88 && usuario.usuario.idRol !== 89">
            <a class="d-flex align-items-center" href="#/mdp/parametrizaciones" data-toggle="tooltip"
               data-placement="auto" title="Parametrizaciones Administracion">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Parametrización</span></a>
          </li>
          <!--<li class="nav-item" *ngIf="usuario.usuario.idRol === 1">
            <a class="d-flex align-items-center" [routerLink]="['gd/inventario/list']" data-toggle="tooltip"
               data-placement="auto" title="Super Barato">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Inventario</span>
            </a>
          </li>-->
          <li class="nav-item has-sub ng-star-inserted"
              *ngIf="usuario.usuario.idRol !== 67 && usuario.usuario.idRol !== 68 && usuario.usuario.idRol !== 69 && usuario.usuario.idRol !== 72 && usuario.usuario.idRol !== 73 && usuario.usuario.idRol !== 77 && usuario.usuario.idRol !== 78 && usuario.usuario.idRol !== 85 && usuario.usuario.idRol !== 88 && usuario.usuario.idRol !== 89">
            <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
               title="Reportes">
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Reportes</span></a>
            <ul class="menu-content">
              <li class="nav-item" *ngIf="usuario.usuario.idRol === 1">
                <a class="d-flex align-items-center" [routerLink]="['mdp/reportes/movimientos-productos']"
                   data-toggle="tooltip"
                   data-placement="auto" title="Reporte de movimientos de productos">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Reporte de movimientos de productos</span>
                </a>
              </li>
              <li class="nav-item" *ngIf="usuario.usuario.idRol === 1">
                <a class="d-flex align-items-center" [routerLink]="['gd/inventario/reporte/canal']"
                   data-toggle="tooltip"
                   data-placement="auto" title="Reporte de Inventario por Canal">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Reporte de Inventario por Canal</span>
                </a>
              </li>
              <li class="nav-item {{menuToolbar['mdp']['abastRep']}}" *ngIf="usuario.usuario.idRol !== 59">
                <a class="d-flex align-items-center" href="#/mdp/reportes/abastecimiento" data-toggle="tooltip"
                   data-placement="auto" title="Reporte de abastecimiento">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Reporte de abastecimiento</span></a>
              </li>
              <li class="nav-item {{menuToolbar['mdp']['stockRep']}}" *ngIf="usuario.usuario.idRol !== 59">
                <a class="d-flex align-items-center" href="#/mdp/reportes/stock" data-toggle="tooltip"
                   data-placement="auto" title="Reporte de stock">
                  <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                     data-i18n="List">Reporte de stock</span></a>
              </li>
              <li class="nav-item {{menuToolbar['mdp']['caduRep']}}" *ngIf="usuario.usuario.idRol !== 59">
                <a class="d-flex align-items-center" href="#/mdp/reportes/caducidad" data-toggle="tooltip"
                   data-placement="auto" title="Reporte de caducidad de productos">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Reporte de caducidad de productos</span></a>
              </li>
              <li class="nav-item {{menuToolbar['mdp']['rotaRep']}}" *ngIf="usuario.usuario.idRol !== 59">
                <a class="d-flex align-items-center" href="#/mdp/reportes/rotacion" data-toggle="tooltip"
                   data-placement="auto" title="Reporte de rotación de productos">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Reporte de rotación de productos</span></a>
              </li>
              <li class="nav-item {{menuToolbar['mdp']['refilRep']}}" *ngIf="usuario.usuario.idRol !== 59">
                <a class="d-flex align-items-center" href="#/mdp/reportes/refil" data-toggle="tooltip"
                   data-placement="auto" title="Reporte refil">
                  <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                     data-i18n="List">Reporte de refil</span></a>
              </li>
            </ul>
          </li>
          <li class="nav-item has-sub ng-star-inserted"
              *ngIf="usuario.usuario.idRol !== 60 && usuario.usuario.idRol !== 68 && usuario.usuario.idRol !== 69 && usuario.usuario.idRol !== 72 && usuario.usuario.idRol !== 73 && usuario.usuario.idRol !== 77 && usuario.usuario.idRol !== 78 && usuario.usuario.idRol !== 85 && usuario.usuario.idRol !== 88 && usuario.usuario.idRol !== 89">
            <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
               title="Administración de inventario">
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Administración de inventario</span></a>
            <ul class="menu-content">
              <li class="nav-item {{menuToolbar['mdp']['param']}}"
                  *ngIf="usuario.usuario.idRol !== 59 && usuario.usuario.idRol !== 67">
                <a class="d-flex align-items-center" href="#/mdp/gestion-proveedores/cargar-stock-productos"
                   data-toggle="tooltip"
                   data-placement="auto" title="Cargar Stock Productos">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Cargar Megadescuento</span></a>
              </li>
              <li class="nav-item {{menuToolbar['mdp']['param']}}" *ngIf="usuario.usuario.idRol !== 67">
                <a class="d-flex align-items-center" href="#/mdp/gestion-proveedores/cargar-stock-megabahia"
                   data-toggle="tooltip"
                   data-placement="auto" title="Cargar Stock Productos">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Cargar Megabahía</span></a>
              </li>
              <!--<li class="nav-item {{menuToolbar['mdp']['param']}}" *ngIf="usuario.usuario.idRol !== 59">
                <a class="d-flex align-items-center" href="#/mdp/gestion-proveedores/productos" data-toggle="tooltip"
                   data-placement="auto" title="Listar Productos">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Productos</span></a>
              </li>-->
            </ul>
          </li>
          <li class="nav-item has-sub ng-star-inserted">
            <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
               title="Administración de productos">
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Administración productos</span></a>
            <ul class="menu-content">

              <li class="nav-item {{menuToolbar['mdp']['cat']}}"
                  *ngIf="usuario.usuario.idRol !== 59 && usuario.usuario.idRol !== 68 && usuario.usuario.idRol !== 69 && usuario.usuario.idRol !== 72 && usuario.usuario.idRol !== 73 && usuario.usuario.idRol !== 77 && usuario.usuario.idRol !== 78 && usuario.usuario.idRol !== 85 && usuario.usuario.idRol !== 88 && usuario.usuario.idRol !== 89">
                <a class="d-flex align-items-center" href="#/mdp/categorias" data-toggle="tooltip"
                   data-placement="auto" title="Administrar categorias">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Administrar categorias</span></a>
              </li>
              <li class="nav-item {{menuToolbar['mdp']['cat']}}"
                  *ngIf="usuario.usuario.idRol !== 59 && usuario.usuario.idRol !== 68 && usuario.usuario.idRol !== 69 && usuario.usuario.idRol !== 72 && usuario.usuario.idRol !== 73 && usuario.usuario.idRol !== 77 && usuario.usuario.idRol !== 78 && usuario.usuario.idRol !== 85 && usuario.usuario.idRol !== 88 && usuario.usuario.idRol !== 89">
                <a class="d-flex align-items-center" href="#/mdp/categorias-especiales" data-toggle="tooltip"
                   data-placement="auto" title="Administrar categorias especiales">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Administración de categorias especiales</span></a>
              </li>
              <li class="nav-item {{menuToolbar['mdp']['subCat']}}"
                  *ngIf="usuario.usuario.idRol !== 59 && usuario.usuario.idRol !== 68 && usuario.usuario.idRol !== 69 && usuario.usuario.idRol !== 72 && usuario.usuario.idRol !== 73 && usuario.usuario.idRol !== 77 && usuario.usuario.idRol !== 78 && usuario.usuario.idRol !== 85 && usuario.usuario.idRol !== 88 && usuario.usuario.idRol !== 89">
                <a class="d-flex align-items-center" href="#/mdp/subcategorias" data-toggle="tooltip"
                   data-placement="auto" title="Administrar subcategorías">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Administrar subcategorías</span></a>
              </li>
              <li class="nav-item {{menuToolbar['mdp']['prodList']}}" *ngIf="usuario.usuario.idRol !== 68">
                <a class="d-flex align-items-center" href="#/mdp/productos" data-toggle="tooltip"
                   data-placement="auto" title="Listado de productos">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Listado de productos</span></a>
              </li>

              <li class="nav-item has-sub ng-star-inserted"
                  *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 67 || usuario.usuario.idRol === 68 || usuario.usuario.idRol === 73 || usuario.usuario.idRol === 78 || usuario.usuario.idRol === 86 || usuario.usuario.idRol === 88 || usuario.usuario.idRol === 89">
                <a class="d-flex align-items-center ml-0" data-toggle="tooltip" data-placement="auto"
                   title="Actualizar stock de inventario">
                  <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                     data-i18n="List">Actualizar stock de inventario</span></a>
                <ul class="menu-content">
                  <li class="nav-item has-sub ng-star-inserted" *ngIf="usuario.usuario.idRol !== 73">
                    <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
                       title="Resetear stock">
                      <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                         data-i18n="List">Resetear stock</span></a>
                    <ul class="menu-content">
                      <li class="nav-item">
                        <a class="d-flex align-items-center ml-2"
                           href="#/mdp/gestion-proveedores/actualizar-inventario/resetear"
                           data-toggle="tooltip"
                           data-placement="auto" title="Carga de archivo">
                          <i data-feather="circle"></i>
                          <span class="menu-item text-truncate" data-i18n="List">Carga de archivo</span></a>
                      </li>
                      <li class="nav-item">
                        <a class="d-flex align-items-center ml-2"
                           href="#/mdp/gestion-proveedores/actualizar-inventario-manual/resetear"
                           data-toggle="tooltip"
                           data-placement="auto" title="Manual/Individual">
                          <i data-feather="circle"></i>
                          <span class="menu-item text-truncate" data-i18n="List">Manual/Individual</span></a>
                      </li>
                    </ul>
                  </li>
                  <li class="nav-item has-sub ng-star-inserted">
                    <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
                       title="Sumar stock">
                      <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                         data-i18n="List">Sumar stock</span></a>
                    <ul class="menu-content">
                      <li class="nav-item">
                        <a class="d-flex align-items-center ml-2"
                           href="#/mdp/gestion-proveedores/actualizar-inventario/sumar"
                           data-toggle="tooltip"
                           data-placement="auto" title="Carga de archivo">
                          <i data-feather="circle"></i>
                          <span class="menu-item text-truncate" data-i18n="List">Carga de archivo</span></a>
                      </li>
                      <li class="nav-item">
                        <a class="d-flex align-items-center ml-2"
                           href="#/mdp/gestion-proveedores/actualizar-inventario-manual/sumar"
                           data-toggle="tooltip"
                           data-placement="auto" title="Manual/Individual">
                          <i data-feather="circle"></i>
                          <span class="menu-item text-truncate" data-i18n="List">Manual/Individual</span></a>
                      </li>
                    </ul>
                  </li>
                  <li class="nav-item has-sub ng-star-inserted">
                    <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
                       title="Restar stock">
                      <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                         data-i18n="List">Restar stock</span></a>
                    <ul class="menu-content">
                      <li class="nav-item">
                        <a class="d-flex align-items-center ml-2"
                           href="#/mdp/gestion-proveedores/actualizar-inventario/restar"
                           data-toggle="tooltip"
                           data-placement="auto" title="Carga de archivo">
                          <i data-feather="circle"></i>
                          <span class="menu-item text-truncate" data-i18n="List">Carga de archivo</span></a>
                      </li>
                      <li class="nav-item">
                        <a class="d-flex align-items-center ml-2"
                           href="#/mdp/gestion-proveedores/actualizar-inventario-manual/restar"
                           data-toggle="tooltip"
                           data-placement="auto" title="Manual/Individual">
                          <i data-feather="circle"></i>
                          <span class="menu-item text-truncate" data-i18n="List">Manual/Individual</span></a>
                      </li>
                    </ul>
                  </li>

                </ul>
              </li>
              <!--<li class="nav-item {{menuToolbar['mdp']['param']}}" *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 67 || usuario.usuario.idRol === 68">
              <li class="nav-item {{menuToolbar['mdp']['param']}}" *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 67 || usuario.usuario.idRol === 73 || usuario.usuario.idRol === 78 || usuario.usuario.idRol === 77">
                <a class="d-flex align-items-center" href="#/mdp/gestion-proveedores/cargar-stock-canales"
                   data-toggle="tooltip"
                   data-placement="auto" title="Actualizar precios de inventario por canal">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Actualizar precios de inventario por canal</span></a>
              </li>-->
              <li class="nav-item has-sub ng-star-inserted"
                  *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 67 || usuario.usuario.idRol === 73 || usuario.usuario.idRol === 78 || usuario.usuario.idRol === 77 || usuario.usuario.idRol === 86 || usuario.usuario.idRol === 88 || usuario.usuario.idRol === 89">
                <a class="d-flex align-items-center ml-0" data-toggle="tooltip" data-placement="auto"
                   title="Actualizar precios de inventario por canal">
                  <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                     data-i18n="List">Actualizar precios de inventario por canal</span></a>
                <ul class="menu-content">

                  <li class="nav-item">
                    <a class="d-flex align-items-center" href="#/mdp/gestion-proveedores/cargar-stock-canales"
                       data-toggle="tooltip"
                       data-placement="auto" title="Carga de archivo">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Carga de archivo</span></a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center"
                       href="#/mdp/gestion-proveedores/actualizar-inventario-manual/precios"
                       data-toggle="tooltip"
                       data-placement="auto" title="Manual/Individual">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Manual/Individual</span></a>
                  </li>
                </ul>
              </li>

              <!--<li class="nav-item {{menuToolbar['mdp']['prodBusq']}}" *ngIf="usuario.usuario.idRol !== 59">
                <a class="d-flex align-items-center" href="#/mdp/productos/search" data-toggle="tooltip"
                   data-placement="auto" title="Buscar productos">
                  <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                     data-i18n="List">Buscar productos</span></a>
              </li>
              <li class="nav-item {{menuToolbar['mdp']['stockAct']}}" *ngIf="usuario.usuario.idRol !== 59">
                <a class="d-flex align-items-center" href="#/mdp/productos/actualizarStock" data-toggle="tooltip"
                   data-placement="auto" title="Actualizar Stock de productos">
                  <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                     data-i18n="List">Actualizar Stock</span></a>
              </li>
              <li class="nav-item {{menuToolbar['mdp']['abastRep']}}" *ngIf="usuario.usuario.idRol !== 59">
                <a class="d-flex align-items-center" href="#/mdp/reportes/abastecimiento" data-toggle="tooltip"
                   data-placement="auto" title="Reporte de abastecimiento">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Reporte de abastecimiento</span></a>
              </li>
              <li class="nav-item {{menuToolbar['mdp']['stockRep']}}" *ngIf="usuario.usuario.idRol !== 59">
                <a class="d-flex align-items-center" href="#/mdp/reportes/stock" data-toggle="tooltip"
                   data-placement="auto" title="Reporte de stock">
                  <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                     data-i18n="List">Reporte de stock</span></a>
              </li>
              <li class="nav-item {{menuToolbar['mdp']['caduRep']}}" *ngIf="usuario.usuario.idRol !== 59">
                <a class="d-flex align-items-center" href="#/mdp/reportes/caducidad" data-toggle="tooltip"
                   data-placement="auto" title="Reporte de caducidad de productos">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Reporte de caducidad de productos</span></a>
              </li>
              <li class="nav-item {{menuToolbar['mdp']['rotaRep']}}" *ngIf="usuario.usuario.idRol !== 59">
                <a class="d-flex align-items-center" href="#/mdp/reportes/rotacion" data-toggle="tooltip"
                   data-placement="auto" title="Reporte de rotación de productos">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Reporte de rotación de productos</span></a>
              </li>
              <li class="nav-item {{menuToolbar['mdp']['refilRep']}}" *ngIf="usuario.usuario.idRol !== 59">
                <a class="d-flex align-items-center" href="#/mdp/reportes/refil" data-toggle="tooltip"
                   data-placement="auto" title="Reporte refil">
                  <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                     data-i18n="List">Reporte de refil</span></a>
              </li>-->
            </ul>
          </li>
          <li class="nav-item has-sub ng-star-inserted"
              *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 68 || usuario.usuario.idRol === 86 || usuario.usuario.idRol === 89">
            <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
               title="Administración de stock virtual">
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Administración de stock virtual</span></a>
            <ul class="menu-content">

              <li class="nav-item {{menuToolbar['mdp']['prodStockVirtualList']}}">
                <a class="d-flex align-items-center" href="#/mdp/stock-virtual/asignacion" data-toggle="tooltip"
                   data-placement="auto" title="Asignación de Stock Virtual">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Asignación de Stock Virtual</span></a>
              </li>
              <li class="nav-item {{menuToolbar['mdp']['prodStockVirtualList']}}"
                  *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 86 || usuario.usuario.idRol === 89">
                <a class="d-flex align-items-center" href="#/mdp/stock-virtual/sincronizacion-automatica"
                   data-toggle="tooltip"
                   data-placement="auto" title="Sincronización automática para stock virutal">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Sincronización automática para stock virtual</span></a>
              </li>
              <li class="nav-item {{menuToolbar['mdp']['prodStockVirtualList']}}"
                  *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 86 || usuario.usuario.idRol === 89">
                <a class="d-flex align-items-center" href="#/mdp/stock-virtual/asignacion/pendiente"
                   data-toggle="tooltip"
                   data-placement="auto" title="Productos pendientes de asignación virtual">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Productos pendientes de asignación virtual</span></a>
              </li>
              <li class="nav-item {{menuToolbar['mdp']['prodStockVirtualList']}}"
                  *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 86 || usuario.usuario.idRol === 89">
                <a class="d-flex align-items-center" href="#/mdp/stock-virtual/asignados" data-toggle="tooltip"
                   data-placement="auto" title="Productos asignados virtuales">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Productos asignados virtuales</span></a>
              </li>
              <li class="nav-item {{menuToolbar['mdp']['prodStockVirtualList']}}">
                <a class="d-flex align-items-center" href="#/mdp/stock-virtual/list" data-toggle="tooltip"
                   data-placement="auto" title="Asignación de precios a productos virtuales">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Asignación de precios a productos virtuales</span></a>
              </li>

            </ul>
          </li>

          <li class="nav-item {{menuToolbar['mdp']['param']}}"
              *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 86">
            <a class="d-flex align-items-center" href="#/mdp/gestion-proveedores/cargar-inventario-catalogo"
               data-toggle="tooltip"
               data-placement="auto" title="Cargar Catálogo desde Woocommerce">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Cargar Catálogo desde Woocommerce</span></a>
          </li>
        </ul>
      </li>
      <li class="nav-item" *ngIf="acciones.PPE.LEER">
        <a class="d-flex align-items-center" title="PPE Productos en Puntos de Entrega">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">PPE Productos en Puntos de Entrega</span></a>
        <ul class="menu-content">

          <li class="nav-item">
            <a class="d-flex align-items-center" [routerLink]="['ppe/punto-entrega/enviar']" data-toggle="tooltip"
               data-placement="auto" title="Enviar productos a punto de entrega">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Enviar productos a punto de entrega</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="d-flex align-items-center" [routerLink]="['ppe/punto-entrega/lista']" data-toggle="tooltip"
               data-placement="auto" title="Lista de envios a punto de entrega">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Lista de envios a punto de entrega</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="d-flex align-items-center" [routerLink]="['ppe/punto-entrega/recibir']" data-toggle="tooltip"
               data-placement="auto" title="Recibir envios">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Recibir envios</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="d-flex align-items-center" [routerLink]="['ppe/punto-entrega/recibidos']" data-toggle="tooltip"
               data-placement="auto" title="Productos a puntos de entrega recibidos">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Productos a puntos de entrega recibidos</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="d-flex align-items-center" [routerLink]="['ppe/punto-entrega/contactos/tienda']"
               data-toggle="tooltip"
               data-placement="auto" title="Contactos de tienda a punto de entrega">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Contactos de tienda a punto de entrega
              </span>
            </a>
          </li>
        </ul>
      </li>
      <li class="nav-item" *ngIf="acciones.DSDROPI.LEER">
        <a class="d-flex align-items-center" title="DS Dropi">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">DS Dropi</span></a>
        <ul class="menu-content">
          <li class="nav-item">
            <a class="d-flex align-items-center" [routerLink]="['ds/dropi/afinamiento-productos']" data-toggle="tooltip"
               data-placement="auto" title="Afinamiento de productos">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Afinamiento de productos</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="d-flex align-items-center" [routerLink]="['ds/dropi/asignacion-precio']" data-toggle="tooltip"
               data-placement="auto" title="Asignación de precio para Dropi">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Asignación de precio para Dropi</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="d-flex align-items-center" [routerLink]="['ds/dropi/carga-producto-dropi']" data-toggle="tooltip"
               data-placement="auto" title="Cargar productos a Dropi">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Cargar productos a Dropi</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="d-flex align-items-center" [routerLink]="['ds/dropi/reporte-productos-dropi']" data-toggle="tooltip"
               data-placement="auto" title="Reporte de Productos Dropi">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Reporte de Productos Dropi</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="d-flex align-items-center" [routerLink]="['ds/dropi/archivo-productos-dropi']" data-toggle="tooltip"
               data-placement="auto" title="Archivo para actualizar stock y precio">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Archivo para actualizar stock y precio</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="d-flex align-items-center" [routerLink]="['ds/dropi/consulta/link-dropi']" data-toggle="tooltip"
               data-placement="auto" title="Consulta link público Dropi">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Consulta link público Dropi</span>
            </a>
          </li>
        </ul>
      </li>
      <li class="ml-2"
          *ngIf="usuario.usuario.idRol !== 80 && usuario.usuario.idRol !== 84 && usuario.usuario.idRol !== 87 && (acciones.MDDAC.LEER || acciones.MDRP.LEER || (acciones.MDP.LEER && (usuario.usuario.idRol !== 85 && usuario.usuario.idRol !== 86 || usuario.usuario.idRol !== 85 || usuario.usuario.idRol !== 68)) || acciones.PPE.LEER)">
        -------------------------------------
      </li>

      <li class="navigation-header"
          *ngIf="usuario.usuario.idRol !== 84 && usuario.usuario.idRol !== 87 && (acciones.MSM.LEER || acciones.MDAV.LEER)">
        SOPORTE DE VENTAS
      </li>
      <li class="nav-item" *ngIf="acciones.MSM.LEER">
        <a class="d-flex align-items-center" title="MSM Master para Soporte Marketing">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">MSM Master para Soporte Marketing</span></a>
        <ul class="menu-content ng-star-inserted">

          <li class="nav-item has-sub ng-star-inserted"
              *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 89">
            <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
               title="Parametrizaciones">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Parametrizaciones</span></a>
            <ul class="menu-content">
              <li class="nav-item" *ngIf="usuario.usuario.idRol !== 89">
                <a class="d-flex align-items-center" [routerLink]="['msm/parametrizaciones']" data-toggle="tooltip"
                   data-placement="auto" title="Parametrizaciones del modulo">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Parametrizaciones del modulo</span></a>
              </li>
              <li class="nav-item">
                <a class="d-flex align-items-center" [routerLink]="['msm/configuracion-modal']" data-toggle="tooltip"
                   data-placement="auto" title="Configuración de modales para links">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Configuración de modales para links</span></a>
              </li>
            </ul>
          </li>
          <li class="nav-item has-sub ng-star-inserted"
              *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 89">
            <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
               title="Gestión de tiendas">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Gestión de tiendas</span></a>
            <ul class="menu-content">
              <li class="nav-item has-sub ng-star-inserted"
                  *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 86 || usuario.usuario.idRol === 89">
                <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
                    title="Administración de tiendas">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Administración de tiendas</span></a>
                <ul class="menu-content">
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['msm/configuracion-productos/productos']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Configuración para productos">
                      <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Configuración para productos</span></a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['msm/configuracion-productos/productos-recientes']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Configuración para productos recientes">
                      <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Configuración para productos recientes</span></a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['msm/gestion/tienda']" data-toggle="tooltip"
                       data-placement="auto" title="Gestión de Tiendas">
                      <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                         data-i18n="List">Gestión de Tiendas</span></a>
                  </li>
                </ul>
              </li>
              <li class="nav-item has-sub ng-star-inserted"
                  *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 86 || usuario.usuario.idRol === 89">
                <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
                   title="Administración de tiendas (CORNER)">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Administración de tiendas (CORNER)</span></a>
                <ul class="menu-content">
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['msm/gestion/tienda/punto-entrega']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Configuración de tienda punto entrega">
                      <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Configuración de tienda punto entrega</span></a>
                  </li>
                </ul>
              </li>
            </ul>
          </li>

          <li class="nav-item has-sub ng-star-inserted"
              *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 67 || usuario.usuario.idRol === 72 || usuario.usuario.idRol === 73 || usuario.usuario.idRol === 78 || usuario.usuario.idRol === 86 || usuario.usuario.idRol === 89">
            <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
               title="Afinamiento de productos">
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Afinamiento de productos</span></a>
            <ul class="menu-content">
              <li class="nav-item {{menuToolbar['mdp']['param']}}"
                  *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 67 || usuario.usuario.idRol === 72 || usuario.usuario.idRol === 73 || usuario.usuario.idRol === 78 || usuario.usuario.idRol === 86 || usuario.usuario.idRol === 89">
                <a class="d-flex align-items-center" href="#/mdp/productos/reporte/sin-titulo"
                   data-toggle="tooltip"
                   data-placement="auto" title="Reporte de productos sin titulos">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Reporte de productos sin titulos</span></a>
              </li>

              <li class="nav-item {{menuToolbar['mdp']['param']}}"
                  *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 72 || usuario.usuario.idRol === 73 || usuario.usuario.idRol === 78 || usuario.usuario.idRol === 86 || usuario.usuario.idRol === 89">
                <a class="d-flex align-items-center" href="#/mdp/gestion-proveedores/actualizar-inventario/titulos"
                   data-toggle="tooltip"
                   data-placement="auto" title="Actualizar titulos">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Actualizar titulos</span></a>
              </li>
              <li class="nav-item {{menuToolbar['mdp']['param']}}"
                  *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 73 || usuario.usuario.idRol === 78 || usuario.usuario.idRol === 86 || usuario.usuario.idRol === 89">
                <a class="d-flex align-items-center" href="#/mdp/productos/reporte/sin-multimedia"
                   data-toggle="tooltip"
                   data-placement="auto" title="Reporte de productos sin multimedia">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Reporte de productos sin multimedia</span></a>
              </li>
            </ul>
          </li>

          <li class="nav-item has-sub ng-star-inserted"
              *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 89 || usuario.usuario.idRol === 90">
            <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
               title="Gestión de combos">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Gestión de combos</span></a>
            <ul class="menu-content">
              <li class="nav-item has-sub ng-star-inserted"
                  *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 86 || usuario.usuario.idRol === 89">
                <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
                   title="Administración de combos virtuales">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Administración de combos virtuales</span></a>
                <ul class="menu-content">
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['msm/configuracion-productos/combo-productos']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Configuración para combos virtuales">
                      <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Configuración para combos virtuales</span></a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['mdp/combo-productos/crear']" data-toggle="tooltip"
                       data-placement="auto" title="Crear combo virtual">
                      <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Crear combo virtual</span></a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['mdp/combo-productos/lista']" data-toggle="tooltip"
                       data-placement="auto" title="Lista de combos virtuales">
                      <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Lista de combos virtuales</span></a>
                  </li>
                </ul>
              </li>
              <li class="nav-item has-sub ng-star-inserted"
                  *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 89 || usuario.usuario.idRol === 90">
                <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
                   title="Administración de pautas">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Administración de combo de pautas</span></a>
                <ul class="menu-content">
                  <li class="nav-item" *ngIf="usuario.usuario.idRol !== 90">
                    <a class="d-flex align-items-center" [routerLink]="['msm/configuracion/tiempo-entrega-sector']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Configuración tiempo entrega por sectores">
                      <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Configuración tiempo entrega por sectores</span></a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['msm/combo-pautas/crear']" data-toggle="tooltip"
                       data-placement="auto" title="Crear combo para pauta">
                      <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Crear combo para pautas</span></a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['msm/combo-pautas/generar/link']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Generar link para pauta">
                      <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Generar link para pauta</span></a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['msm/combo-pautas/generar/link/multiple']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Generar link para pauta (Múltiples combos)">
                      <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Generar link para pauta (Múltiples combos)</span></a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['msm/combo-pautas/generar/link/historia']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Generar link para pauta historia">
                      <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Generar link para pauta historia</span></a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['msm/combo-pautas/generar/link/market']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Generar link para pauta market">
                      <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Generar link para pauta market</span></a>
                  </li>
                </ul>
              </li>
            </ul>
          </li>

          <li class="nav-item has-sub ng-star-inserted"
              *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 89">
            <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
               title="Gestión de productos">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Gestión de productos</span></a>
            <ul class="menu-content">
              <li class="nav-item has-sub ng-star-inserted"
                  *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 86 || usuario.usuario.idRol === 89">
                <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
                   title="Administración de Productos Gratis">
                  <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                     data-i18n="List">Administración de Productos Gratis</span></a>
                <ul class="menu-content">
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['msm/configuracion-productos/productos-gratis']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Configuración para productos gratis">
                      <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Configuración para productos gratis</span></a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['msm/productos-gratis/crear']" data-toggle="tooltip"
                       data-placement="auto" title="Creación de productos gratis">
                      <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Creación de productos gratis</span></a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['msm/productos-gratis/lista']" data-toggle="tooltip"
                       data-placement="auto" title="Productos gratis">
                      <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                         data-i18n="List">Productos gratis</span></a>
                  </li>
                </ul>
              </li>
              <li class="nav-item has-sub ng-star-inserted"
                  *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 86 || usuario.usuario.idRol === 89">
                <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
                   title="Administración de productos oferta y mitad de precio">
                  <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                     data-i18n="List">Administración de productos oferta y mitad de precio</span></a>
                <ul class="menu-content">
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['msm/configuracion-productos/productos-oferta']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Configuración para productos oferta y mitad de precio">
                      <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Configuración para productos oferta y mitad de precio</span></a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['msm/productos-oferta/crear']" data-toggle="tooltip"
                       data-placement="auto" title="Creación de productos oferta y mitad de precio">
                      <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Creación de productos oferta y mitad de precio</span></a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['msm/productos-oferta/lista']" data-toggle="tooltip"
                       data-placement="auto" title="Productos oferta y mitad de precio">
                      <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Productos oferta y mitad de precio</span></a>
                  </li>
                </ul>
              </li>
              <li class="nav-item has-sub ng-star-inserted"
                  *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 86 || usuario.usuario.idRol === 89">
                <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
                   title="Administración de productos venta semana">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Administración de productos venta semana</span></a>
                <ul class="menu-content">
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['msm/configurar/landing']" data-toggle="tooltip"
                       data-placement="auto" title="Configuración de landing por canal">
                      <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Configuración de landing por canal</span></a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['msm/productos-venta-semana/crear']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Crear productos venta semana">
                      <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Crear productos venta semana</span></a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['msm/productos-venta-semana/lista']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Productos venta para semana">
                      <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Productos venta para semana</span></a>
                  </li>
                </ul>
              </li>

            </ul>
          </li>
          <li class="nav-item has-sub ng-star-inserted"
              *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 86 || usuario.usuario.idRol === 89">
            <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
               title="Administraciòn de archivos CSV WOOCOMMERCE">
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Administración de archivos CSV WOOCOMMERCE</span></a>
            <ul class="menu-content">
              <li class="nav-item">
                <a class="d-flex align-items-center" data-toggle="tooltip" [routerLink]="['mdp/archivos-csv/generar']"
                   data-placement="auto" title="Generar archivos CSV WOOCOMMERCE">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Generar archivos CSV WOOCOMMERCE</span></a>
              </li>
            </ul>
          </li>
          <li class="nav-item has-sub ng-star-inserted"
              *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 89">
            <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
               title="Gestión de marketing orgánico">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Gestión de publicaciones</span></a>
            <ul class="menu-content">
              <li class="nav-item has-sub ng-star-inserted"
                  *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 86 || usuario.usuario.idRol === 89">
                <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
                   title="Registro de publicaciones">
                  <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                     data-i18n="List">Registro de publicaciones</span></a>
                <ul class="menu-content">
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['gd/publicacion/crear']" data-toggle="tooltip"
                       data-placement="auto" title="Registro de publicaciones">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Registro de publicaciones</span>
                    </a>
                  </li>
                  <li class="nav-item" *ngIf="acciones.GCN.LEER || usuario.usuario.idRol === 64 || usuario.usuario.idRol === 89">
                    <a class="d-flex align-items-center" [routerLink]="['gd/publicacion/lista']" data-toggle="tooltip"
                       data-placement="auto" title="Reporte de lista de publicaciones">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Reporte de lista de publicaciones</span>
                    </a>
                  </li>
                </ul>
              </li>
              <li class="nav-item has-sub ng-star-inserted"
                  *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 64 || usuario.usuario.idRol === 58 || usuario.usuario.idRol === 54 || usuario.usuario.idRol === 86 || usuario.usuario.idRol === 89">
                <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
                   title="Registro de contactos">
                  <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                     data-i18n="List">Registro de contactos</span></a>
                <ul class="menu-content">
                  <li class="nav-item"
                      *ngIf="usuario.usuario.idRol === 58 || usuario.usuario.idRol === 1 || usuario.usuario.idRol === 54 || usuario.usuario.idRol === 64 || usuario.usuario.idRol === 86 || usuario.usuario.idRol === 89">
                    <a class="d-flex align-items-center" [routerLink]="['gd/contacto/crear']" data-toggle="tooltip"
                       data-placement="auto" title="Ingreso de contactos">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Ingresar Contactos</span>
                    </a>
                  </li>
                  <li class="nav-item"
                      *ngIf="acciones.GCN.LEER || usuario.usuario.idRol === 64 || usuario.usuario.idRol === 86 || usuario.usuario.idRol === 89">
                    <a class="d-flex align-items-center" [routerLink]="['gd/contacto/lista/reporte']" data-toggle="tooltip"
                       data-placement="auto" title="Reporte de lista de contactos">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Reporte de lista de contactos</span>
                    </a>
                  </li>
                </ul>
              </li>
              <li class="nav-item has-sub ng-star-inserted"
                  *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 80 || usuario.usuario.idRol === 89">
                <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
                   title="Gestión de Marketing Orgánico">
                  <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                     data-i18n="List">Gestión de Marketing Orgánico</span></a>
                <ul class="menu-content">
                  <li class="nav-item has-sub ng-star-inserted">
                    <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
                       title="Marketing Orgánico de Facebook">
                      <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                         data-i18n="List">Marketing Orgánico de Facebook</span></a>
                    <ul class="menu-content">
                      <li class="nav-item" *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 89">
                        <a class="d-flex align-items-center" [routerLink]="['gd/marketing-organico/facebook/productos']"
                           data-toggle="tooltip"
                           data-placement="auto" title="Productos para publicar">
                          <i data-feather="circle"></i>
                          <span class="menu-item text-truncate" data-i18n="List">Productos para publicar</span>
                        </a>
                      </li>
                      <li class="nav-item"
                          *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 86 || usuario.usuario.idRol === 89">
                        <a class="d-flex align-items-center" [routerLink]="['gd/publicacion/facebook/aprobaciones']"
                           data-toggle="tooltip"
                           data-placement="auto" title="Aprobación de publicaciones">
                          <i data-feather="circle"></i>
                          <span class="menu-item text-truncate" data-i18n="List">Aprobación de publicaciones</span>
                        </a>
                      </li>
                      <li class="nav-item"
                          *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 86 || usuario.usuario.idRol === 80 || usuario.usuario.idRol === 89">
                        <a class="d-flex align-items-center" [routerLink]="['gd/publicacion/facebook/lista']"
                           data-toggle="tooltip"
                           data-placement="auto" title="Publicaciones aprobadas de facebook">
                          <i data-feather="circle"></i>
                          <span class="menu-item text-truncate" data-i18n="List">Reporte de publicaciones aprobadas de facebook</span>
                        </a>
                      </li>
                      <li class="nav-item"
                          *ngIf="acciones.GCN.LEER || usuario.usuario.idRol === 64 || usuario.usuario.idRol === 86 || usuario.usuario.idRol === 89">
                        <a class="d-flex align-items-center"
                           [routerLink]="['gd/marketing-organico/facebook/registro-contacto']"
                           data-toggle="tooltip"
                           data-placement="auto" title="Registrar contacto de productos publicados">
                          <i data-feather="circle"></i>
                          <span class="menu-item text-truncate"
                                data-i18n="List">Registrar contacto de productos publicados</span>
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li class="nav-item has-sub ng-star-inserted">
                    <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
                       title="Marketing Orgánico de Instagram">
                      <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                         data-i18n="List">Marketing Orgánico de Instagram</span></a>
                    <ul class="menu-content">
                      <li class="nav-item" *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 89">
                        <a class="d-flex align-items-center" [routerLink]="['gd/marketing-organico/instagram/productos']"
                           data-toggle="tooltip"
                           data-placement="auto" title="Productos para publicar">
                          <i data-feather="circle"></i>
                          <span class="menu-item text-truncate" data-i18n="List">Productos para publicar</span>
                        </a>
                      </li>
                      <li class="nav-item"
                          *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 86 || usuario.usuario.idRol === 89">
                        <a class="d-flex align-items-center" [routerLink]="['gd/publicacion/instagram/aprobaciones']"
                           data-toggle="tooltip"
                           data-placement="auto" title="Aprobación de publicaciones">
                          <i data-feather="circle"></i>
                          <span class="menu-item text-truncate" data-i18n="List">Aprobación de publicaciones</span>
                        </a>
                      </li>
                      <li class="nav-item"
                          *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 86 || usuario.usuario.idRol === 80 || usuario.usuario.idRol === 89">
                        <a class="d-flex align-items-center" [routerLink]="['gd/publicacion/instagram/lista']"
                           data-toggle="tooltip"
                           data-placement="auto" title="Publicaciones aprobadas de instagram">
                          <i data-feather="circle"></i>
                          <span class="menu-item text-truncate" data-i18n="List">Reporte de publicaciones aprobadas de instagram</span>
                        </a>
                      </li>
                      <li class="nav-item"
                          *ngIf="acciones.GCN.LEER || usuario.usuario.idRol === 64 || usuario.usuario.idRol === 86 || usuario.usuario.idRol === 89">
                        <a class="d-flex align-items-center"
                           [routerLink]="['gd/marketing-organico/instagram/registro-contacto']"
                           data-toggle="tooltip"
                           data-placement="auto" title="Registrar contacto de productos publicados">
                          <i data-feather="circle"></i>
                          <span class="menu-item text-truncate"
                                data-i18n="List">Registrar contacto de productos publicados</span>
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li class="nav-item has-sub ng-star-inserted">
                    <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
                       title="Marketing Orgánico de Tiktok">
                      <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                         data-i18n="List">Marketing Orgánico de Tiktok</span></a>
                    <ul class="menu-content">
                      <li class="nav-item" *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 89">
                        <a class="d-flex align-items-center" [routerLink]="['gd/marketing-organico/tiktok/productos']"
                           data-toggle="tooltip"
                           data-placement="auto" title="Productos para publicar">
                          <i data-feather="circle"></i>
                          <span class="menu-item text-truncate" data-i18n="List">Productos para publicar</span>
                        </a>
                      </li>
                      <li class="nav-item"
                          *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 86 || usuario.usuario.idRol === 89">
                        <a class="d-flex align-items-center" [routerLink]="['gd/publicacion/tiktok/aprobaciones']"
                           data-toggle="tooltip"
                           data-placement="auto" title="Aprobación de publicaciones">
                          <i data-feather="circle"></i>
                          <span class="menu-item text-truncate" data-i18n="List">Aprobación de publicaciones</span>
                        </a>
                      </li>
                      <li class="nav-item"
                          *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 86 || usuario.usuario.idRol === 80 || usuario.usuario.idRol === 89">
                        <a class="d-flex align-items-center" [routerLink]="['gd/publicacion/tiktok/lista']"
                           data-toggle="tooltip"
                           data-placement="auto" title="Publicaciones aprobadas de tiktok">
                          <i data-feather="circle"></i>
                          <span class="menu-item text-truncate" data-i18n="List">Reporte de publicaciones aprobadas de tiktok</span>
                        </a>
                      </li>
                      <li class="nav-item"
                          *ngIf="acciones.GCN.LEER || usuario.usuario.idRol === 64 || usuario.usuario.idRol === 86 || usuario.usuario.idRol === 89">
                        <a class="d-flex align-items-center"
                           [routerLink]="['gd/marketing-organico/tiktok/registro-contacto']"
                           data-toggle="tooltip"
                           data-placement="auto" title="Registrar contacto de productos publicados">
                          <i data-feather="circle"></i>
                          <span class="menu-item text-truncate"
                                data-i18n="List">Registrar contacto de productos publicados</span>
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li class="nav-item has-sub ng-star-inserted">
                    <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
                       title="Marketing Orgánico de Facebook_Post">
                      <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                         data-i18n="List">Marketing Orgánico de Facebook_Post</span></a>
                    <ul class="menu-content">
                      <li class="nav-item" *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 89">
                        <a class="d-flex align-items-center"
                           [routerLink]="['gd/marketing-organico/facebook_post/productos']"
                           data-toggle="tooltip"
                           data-placement="auto" title="Productos para publicar">
                          <i data-feather="circle"></i>
                          <span class="menu-item text-truncate" data-i18n="List">Productos para publicar</span>
                        </a>
                      </li>
                      <li class="nav-item"
                          *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 86 || usuario.usuario.idRol === 89">
                        <a class="d-flex align-items-center" [routerLink]="['gd/publicacion/facebook_post/aprobaciones']"
                           data-toggle="tooltip"
                           data-placement="auto" title="Aprobación de publicaciones">
                          <i data-feather="circle"></i>
                          <span class="menu-item text-truncate" data-i18n="List">Aprobación de publicaciones</span>
                        </a>
                      </li>
                      <li class="nav-item"
                          *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 86 || usuario.usuario.idRol === 80 || usuario.usuario.idRol === 89">
                        <a class="d-flex align-items-center" [routerLink]="['gd/publicacion/facebook_post/lista']"
                           data-toggle="tooltip"
                           data-placement="auto" title="Publicaciones aprobadas de facebook_post">
                          <i data-feather="circle"></i>
                          <span class="menu-item text-truncate" data-i18n="List">Reporte de publicaciones aprobadas de facebook_post</span>
                        </a>
                      </li>
                      <li class="nav-item"
                          *ngIf="acciones.GCN.LEER || usuario.usuario.idRol === 64 || usuario.usuario.idRol === 86 || usuario.usuario.idRol === 89">
                        <a class="d-flex align-items-center"
                           [routerLink]="['gd/marketing-organico/facebook_post/registro-contacto']"
                           data-toggle="tooltip"
                           data-placement="auto" title="Registrar contacto de productos publicados">
                          <i data-feather="circle"></i>
                          <span class="menu-item text-truncate"
                                data-i18n="List">Registrar contacto de productos publicados</span>
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li class="nav-item has-sub ng-star-inserted">
                    <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
                       title="Marketing Orgánico de WhatsApp">
                      <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                         data-i18n="List">Marketing Orgánico de WhatsApp</span></a>
                    <ul class="menu-content">
                      <li class="nav-item" *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 89">
                        <a class="d-flex align-items-center" [routerLink]="['gd/marketing-organico/whatsapp/productos']"
                           data-toggle="tooltip"
                           data-placement="auto" title="Productos para publicar">
                          <i data-feather="circle"></i>
                          <span class="menu-item text-truncate" data-i18n="List">Productos para publicar</span>
                        </a>
                      </li>
                      <li class="nav-item"
                          *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 86 || usuario.usuario.idRol === 89">
                        <a class="d-flex align-items-center" [routerLink]="['gd/publicacion/whatsapp/aprobaciones']"
                           data-toggle="tooltip"
                           data-placement="auto" title="Aprobación de publicaciones">
                          <i data-feather="circle"></i>
                          <span class="menu-item text-truncate" data-i18n="List">Aprobación de publicaciones</span>
                        </a>
                      </li>
                      <li class="nav-item"
                          *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 86 || usuario.usuario.idRol === 80 || usuario.usuario.idRol === 89">
                        <a class="d-flex align-items-center" [routerLink]="['gd/publicacion/whatsapp/lista']"
                           data-toggle="tooltip"
                           data-placement="auto" title="Publicaciones aprobadas de whatsapp">
                          <i data-feather="circle"></i>
                          <span class="menu-item text-truncate" data-i18n="List">Reporte de publicaciones aprobadas de whatsapp</span>
                        </a>
                      </li>
                      <li class="nav-item"
                          *ngIf="acciones.GCN.LEER || usuario.usuario.idRol === 64 || usuario.usuario.idRol === 86 || usuario.usuario.idRol === 89">
                        <a class="d-flex align-items-center"
                           [routerLink]="['gd/marketing-organico/whatsapp/registro-contacto']"
                           data-toggle="tooltip"
                           data-placement="auto" title="Registrar contacto de productos publicados">
                          <i data-feather="circle"></i>
                          <span class="menu-item text-truncate"
                                data-i18n="List">Registrar contacto de productos publicados</span>
                        </a>
                      </li>
                    </ul>
                  </li>

                </ul>
              </li>
              <li class="nav-item" *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 86 || usuario.usuario.idRol === 89">
                <a class="d-flex align-items-center" [routerLink]="['msm/agregar-ubicaciones-publicaciones']"
                   data-toggle="tooltip"
                   data-placement="auto" title="Agregar ubicaciones para publicaciones">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Agregar ubicaciones para publicaciones</span></a>
              </li>
            </ul>
          </li>

        </ul>
      </li>
      <li class="nav-item" *ngIf="acciones.MDAV.LEER">
        <a class="d-flex align-items-center" title="MDAV Motor de Asistente Virtual">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">MDAV Motor de Asistente Virtual</span></a>
        <ul class="menu-content ng-star-inserted">
          <li class="nav-item">
            <a class="d-flex align-items-center" [routerLink]="['mdav/parametrizaciones']"
               data-toggle="tooltip"
               data-placement="auto" title="Parametrizaciones">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Parametrizaciones</span></a>
          </li>
          <li class="nav-item">
            <a class="d-flex align-items-center" [routerLink]="['mdav/asistente-virtual-ventas']"
               data-toggle="tooltip"
               data-placement="auto" title="Asistente Virtual para Ventas">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Asistente Virtual para Ventas</span></a>
          </li>
        </ul>
      </li>

      <li class="ml-2"
          *ngIf="usuario.usuario.idRol !== 80 && usuario.usuario.idRol !== 84 && usuario.usuario.idRol !== 87 && (acciones.MSM.LEER || acciones.MDAV.LEER)">
        -------------------------------------
      </li>
      <li class="navigation-header"
          *ngIf="acciones.MDPC.LEER || acciones.MCT.LEER || acciones.MDC.LEER || acciones.MCUM.LEER || acciones.GD.LEER">
        ADMINISTRACION PEDIDOS
      </li>
      <li class="nav-item" *ngIf="acciones.MDPC.LEER">
        <a class="d-flex align-items-center" title="MDPC Motor de pedidos Canales">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">MDPC Motor de pedidos Canales</span></a>
        <ul class="menu-content ng-star-inserted">
          <li class="nav-item"
              *ngIf="usuario.usuario.idRol !== 68 && usuario.usuario.idRol !== 67 && usuario.usuario.idRol !== 74 && usuario.usuario.idRol !== 75 && usuario.usuario.idRol !== 78 && usuario.usuario.idRol !== 77 && usuario.usuario.idRol !== 80 && usuario.usuario.idRol !== 84 && usuario.usuario.idRol !== 87 && usuario.usuario.idRol !== 88 && usuario.usuario.idRol !== 89 && usuario.usuario.idRol !== 90">
            <a class="d-flex align-items-center" [routerLink]="['mdpc/pedidos']" data-toggle="tooltip"
               data-placement="auto" title="Hacer pedidos">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Hacer pedidos</span></a>
          </li>
          <li class="nav-item"
              *ngIf="usuario.usuario.idRol !== 68 && usuario.usuario.idRol !== 67 && usuario.usuario.idRol !== 74 && usuario.usuario.idRol !== 75 && usuario.usuario.idRol !== 78 && usuario.usuario.idRol !== 77 && usuario.usuario.idRol !== 80 && usuario.usuario.idRol !== 84 && usuario.usuario.idRol !== 87 && usuario.usuario.idRol !== 88">
            <a class="d-flex align-items-center" [routerLink]="['mdpc/pedidos/whatsapp']" data-toggle="tooltip"
               data-placement="auto" title="Pedidos desde whatsapp">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Pedidos desde whatsapp</span></a>
          </li>
          <li class="nav-item has-sub ng-star-inserted" *ngIf="usuario.usuario.idRol !== 74 && usuario.usuario.idRol !== 88">
            <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
               title="Pedidos desde tienda virtual">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Pedidos desde tienda virtual</span></a>
            <ul class="menu-content">
              <li class="nav-item"
                  *ngIf="(usuario.usuario.idRol === 80 || usuario.usuario.idRol === 84 || usuario.usuario.idRol === 87) || usuario.usuario.idRol === 84 || usuario.usuario.idRol === 87 || usuario.usuario.idRol === 1 || usuario.usuario.idRol === 89 || usuario.usuario.idRol === 90">
                <a class="d-flex align-items-center" [routerLink]="['mdpc/lista/vistas/tienda']" data-toggle="tooltip"
                   data-placement="auto" title="Visitas a tienda">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Visitas a tienda</span></a>
              </li>
              <li class="nav-item"
                  *ngIf="usuario.usuario.idRol !== 42 && usuario.usuario.idRol !== 70 && usuario.usuario.idRol !== 71 && usuario.usuario.idRol !== 75 && usuario.usuario.idRol !== 76 && usuario.usuario.idRol !== 78 && usuario.usuario.idRol !== 77 && usuario.usuario.idRol !== 79">
                <a class="d-flex align-items-center" [routerLink]="['mdpc/lista/pedidos/tienda']" data-toggle="tooltip"
                   data-placement="auto" title="Pre-Pedidos de tienda">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Pre-Pedidos de tienda</span></a>
              </li>
              <li class="nav-item"
                  *ngIf="usuario.usuario.idRol !== 80 && usuario.usuario.idRol !== 84 && usuario.usuario.idRol !== 87">
                <a class="d-flex align-items-center" [routerLink]="['mdpc/lista/pedidos/tienda/aprobacion']"
                   data-toggle="tooltip"
                   data-placement="auto" title="Aprobación de abono/pago">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Aprobación de abono/pago</span></a>
              </li>
              <li class="nav-item"
                  *ngIf="usuario.usuario.idRol !== 80 && usuario.usuario.idRol !== 84 && usuario.usuario.idRol !== 87">
                <a class="d-flex align-items-center" [routerLink]="['mdpc/lista/pedidos/tienda/rechazados']"
                   data-toggle="tooltip"
                   data-placement="auto" title="Pedidos de tienda rechazados">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Pedidos de tienda rechazados</span></a>
              </li>
            </ul>
          </li>
          <li class="nav-item has-sub ng-star-inserted">
            <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
               title="Control de pedidos">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Control de pedidos</span></a>
            <ul class="menu-content">

              <li class="nav-item"
                  *ngIf="usuario.usuario.idRol !== 42 && usuario.usuario.idRol !== 70 && usuario.usuario.idRol !== 71 && usuario.usuario.idRol !== 75 && usuario.usuario.idRol !== 76 && usuario.usuario.idRol !== 78 && usuario.usuario.idRol !== 77 && usuario.usuario.idRol !== 79 && usuario.usuario.idRol !== 80 && usuario.usuario.idRol !== 84 && usuario.usuario.idRol !== 87 && usuario.usuario.idRol !== 88">
                <a class="d-flex align-items-center" [routerLink]="['mdpc/lista/pedidos/asignacion-guia']" data-toggle="tooltip"
                   data-placement="auto" title="Asignar guía a pedido">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Asignar guía a pedido</span></a>
              </li>
              <li class="nav-item"
                  *ngIf="usuario.usuario.idRol !== 42 && usuario.usuario.idRol !== 70 && usuario.usuario.idRol !== 71 && usuario.usuario.idRol !== 75 && usuario.usuario.idRol !== 76 && usuario.usuario.idRol !== 78 && usuario.usuario.idRol !== 77 && usuario.usuario.idRol !== 79 && usuario.usuario.idRol !== 80 && usuario.usuario.idRol !== 84 && usuario.usuario.idRol !== 87 && usuario.usuario.idRol !== 90">
                <a class="d-flex align-items-center" [routerLink]="['mdpc/lista/pedidos/canales']" data-toggle="tooltip"
                   data-placement="auto" title="Pedidos Canales">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Pedidos Canales</span></a>
              </li>
              <li class="nav-item"
                  *ngIf="usuario.usuario.idRol !== 67 && usuario.usuario.idRol !== 42 && usuario.usuario.idRol !== 70 && usuario.usuario.idRol !== 71 && usuario.usuario.idRol !== 74 && usuario.usuario.idRol !== 76 && usuario.usuario.idRol !== 77 && usuario.usuario.idRol !== 79 && usuario.usuario.idRol !== 80 && usuario.usuario.idRol !== 84 && usuario.usuario.idRol !== 87">
                <a class="d-flex align-items-center" [routerLink]="['mdpc/lista/pedidos/despachados']"
                   data-toggle="tooltip"
                   data-placement="auto" title="Confirmación de envío">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Confirmación de envío</span></a>
              </li>
              <!--<li class="nav-item"
                  *ngIf="usuario.usuario.idRol !== 42 && usuario.usuario.idRol !== 70 && usuario.usuario.idRol !== 71 && usuario.usuario.idRol !== 74 && usuario.usuario.idRol !== 76 && usuario.usuario.idRol !== 77">
                <a class="d-flex align-items-center" [routerLink]="['mdpc/lista/pedidos/enviados']" data-toggle="tooltip"
                   data-placement="auto" title="Pedidos enviados">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Pedidos enviados</span></a>
              </li>-->
              <li class="nav-item"
                  *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 73 || usuario.usuario.idRol === 78 || usuario.usuario.idRol === 75 || usuario.usuario.idRol === 88 || usuario.usuario.idRol === 89">
                <a class="d-flex align-items-center" [routerLink]="['mdpc/gestion-entrega/enviados']"
                   data-toggle="tooltip"
                   data-placement="auto" title="Gestión de enviado">
                  <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                     data-i18n="List">Gestión de enviado</span></a>
              </li>
              <li class="nav-item"
                  *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 73 || usuario.usuario.idRol === 78 || (usuario.usuario.idRol === 80 || usuario.usuario.idRol === 84 || usuario.usuario.idRol === 87) || usuario.usuario.idRol === 84 || usuario.usuario.idRol === 87 || usuario.usuario.idRol === 75 || usuario.usuario.idRol === 88 || usuario.usuario.idRol === 89 || usuario.usuario.idRol === 90">
                <a class="d-flex align-items-center" [routerLink]="['mdpc/gestion-entrega/reporte-pedidos']"
                   data-toggle="tooltip"
                   data-placement="auto" title="Reporte de pedidos">
                  <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                     data-i18n="List">Reporte de pedidos</span></a>
              </li>
              <li
                *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 73 || usuario.usuario.idRol === 78 || usuario.usuario.idRol === 75 || usuario.usuario.idRol === 88 || usuario.usuario.idRol === 89 || usuario.usuario.idRol === 90"
                class="nav-item">
                <a class="d-flex align-items-center" [routerLink]="['mdpc/gestion-entrega/devolucion']"
                   data-toggle="tooltip"
                   data-placement="auto" title="Reporte de devolución de paquetes">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Reporte de devolución de paquetes</span></a>
              </li>
              <li
                *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 73 || usuario.usuario.idRol === 78 || usuario.usuario.idRol === 75 || usuario.usuario.idRol === 88 || usuario.usuario.idRol === 89 || usuario.usuario.idRol === 90"
                class="nav-item">
                <a class="d-flex align-items-center" [routerLink]="['mdpc/gestion-entrega/reporte-entrega']"
                   data-toggle="tooltip"
                   data-placement="auto" title="Reporte de entregas">
                  <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                     data-i18n="List">Reporte de entregas</span></a>
              </li>
              <li class="nav-item"
                  *ngIf="usuario.usuario.idRol !== 68 && usuario.usuario.idRol !== 67 && usuario.usuario.idRol !== 42 && usuario.usuario.idRol !== 74  && usuario.usuario.idRol !== 75 && usuario.usuario.idRol !== 78 && usuario.usuario.idRol !== 88 && usuario.usuario.idRol !== 89 && usuario.usuario.idRol !== 90">
                <a class="d-flex align-items-center" [routerLink]="['mdpc/lista/pedidos/canal']" data-toggle="tooltip"
                   data-placement="auto" title="Pedidos del Usuario para Despacho">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Pedidos del Usuario para Despacho</span></a>
              </li>
              <li class="nav-item has-sub ng-star-inserted"
                  *ngIf="usuario.usuario.idRol !== 68 && usuario.usuario.idRol !== 67 && usuario.usuario.idRol !== 42 && usuario.usuario.idRol !== 74 && usuario.usuario.idRol !== 75 && usuario.usuario.idRol !== 76 && usuario.usuario.idRol !== 79 && usuario.usuario.idRol !== 80 && usuario.usuario.idRol !== 84 && usuario.usuario.idRol !== 87 && usuario.usuario.idRol !== 88 && usuario.usuario.idRol !== 89 && usuario.usuario.idRol !== 90">
                <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
                   title="Pedidos entrega local">
                  <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                     data-i18n="List">Pedidos para entrega en local</span></a>
                <ul class="menu-content">
                  <li class="nav-item"
                      *ngIf="usuario.usuario.idRol !== 68 && usuario.usuario.idRol !== 67 && usuario.usuario.idRol !== 42 && usuario.usuario.idRol !== 77">
                    <a class="d-flex align-items-center" [routerLink]="['mdpc/lista/pedidos/canal/retiro/local']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Pedidos">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Pedidos</span>
                    </a>
                  </li>
                  <li class="nav-item"
                      *ngIf="usuario.usuario.idRol !== 68 && usuario.usuario.idRol !== 67 && usuario.usuario.idRol !== 42 && usuario.usuario.idRol !== 77">
                    <a class="d-flex align-items-center" [routerLink]="['mdpc/lista/pedidos/canal/cuotas']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Confirmar número de autorización pago a 6 cuotas">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Confirmar número de autorización pago a 6 cuotas</span>
                    </a>
                  </li>
                  <li class="nav-item"
                      *ngIf="usuario.usuario.idRol !== 68 && usuario.usuario.idRol !== 67 && usuario.usuario.idRol !== 42 && usuario.usuario.idRol !== 77">
                    <a class="d-flex align-items-center"
                       [routerLink]="['mdpc/lista/pedidos/canal/retiro/local/entregados']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Pedidos entregados">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Pedidos entregados</span>
                    </a>
                  </li>
                  <li class="nav-item" *ngIf="usuario.usuario.idRol !== 73 && usuario.usuario.idRol !== 78">
                    <a class="d-flex align-items-center"
                       [routerLink]="['mdpc/lista/pedidos/canal/retiro/local/reporte']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Reporte de ventas por contacto local">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Reporte de ventas por contacto local</span>
                    </a>
                  </li>
                  <li class="nav-item"
                      *ngIf="usuario.usuario.idRol !== 68 && usuario.usuario.idRol !== 67 && usuario.usuario.idRol !== 42 && usuario.usuario.idRol !== 77">
                    <a class="d-flex align-items-center"
                       [routerLink]="['mdpc/lista/pedidos/canal/retiro/local/confirmacion-facturas-cargadas']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Confirmación de facturas cargadas">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Confirmación de facturas</span>
                    </a>
                  </li>
                  <li class="nav-item"
                      *ngIf="usuario.usuario.idRol !== 68 && usuario.usuario.idRol !== 67 && usuario.usuario.idRol !== 42 && usuario.usuario.idRol !== 77">
                    <a class="d-flex align-items-center"
                       [routerLink]="['mdpc/lista/pedidos/canal/retiro/local/confirmacion-quejas']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Confirmación de quejas">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Confirmación de quejas</span>
                    </a>
                  </li>

                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </li>
      <li class="nav-item" *ngIf="acciones.MDO.LEER">
        <a class="d-flex align-items-center">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">MDO Motor de ofertas</span></a>
        <ul class="menu-content">
          <li class="nav-item {{menuToolbar['mdo']['param']}}" *ngIf="usuario.usuario.idRol !== 90 && usuario.usuario.idRol !== 89">
            <a class="d-flex align-items-center" href="#/mdo/parametrizaciones/list" data-toggle="tooltip"
               data-placement="auto" title="Parametrizaciones MDO">
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Parametrización</span></a>
          </li>
          <li class="nav-item {{menuToolbar['mdo']['param']}}">
            <a class="d-flex align-items-center" href="#/mdo/configuracion-relacion-tienda" data-toggle="tooltip"
               data-placement="auto" title="Configuración de relación de tiendas">
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Configuración de relación de tiendas</span></a>
          </li>
          <li class="nav-item has-sub">
            <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
               title="Gestión Post-Venta pedidos combo pauta">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Gestión Post-Venta pedidos combo pauta</span></a>
            <ul class="menu-content">
              <li class="nav-item {{menuToolbar['mdo']['param']}}">
                <a class="d-flex align-items-center" href="#/mdo/pedidos/combo-pauta/post-venta" data-toggle="tooltip"
                   data-placement="auto" title="Ventas Post-Venta Combo Pauta">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Ventas Post-Venta Combo Pauta</span></a>
              </li>
              <li class="nav-item has-sub">
                <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
                   title="Reporte pedidos combo pauta">
                  <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                     data-i18n="List">Reporte pedidos combo pauta</span></a>
                <ul class="menu-content">
                  <li class="nav-item">
                    <a class="d-flex align-items-center" data-toggle="tooltip"
                       [routerLink]="['mdo/pedidos/combo-pauta/post-venta/entregados']"
                       data-placement="auto" title="Entregados">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Entregados</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center" data-toggle="tooltip"
                       [routerLink]="['mdo/pedidos/combo-pauta/post-venta/devueltos']"
                       data-placement="auto" title="Devueltos">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Devueltos</span>
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li class="nav-item has-sub">
            <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
               title="Gestión Post-Venta pedidos normales">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Gestión Post-Venta pedidos normales</span></a>
            <ul class="menu-content">
              <li class="nav-item {{menuToolbar['mdo']['param']}}">
                <a class="d-flex align-items-center" href="#/mdo/pedidos/normales/post-venta" data-toggle="tooltip"
                   data-placement="auto" title="Ventas Post-Venta">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Ventas Post-Venta</span></a>
              </li>
              <li class="nav-item has-sub">
                <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
                   title="Reporte pedidos">
                  <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                     data-i18n="List">Reporte pedidos</span></a>
                <ul class="menu-content">
                  <li class="nav-item">
                    <a class="d-flex align-items-center" data-toggle="tooltip"
                       [routerLink]="['mdo/pedidos/normales/post-venta/entregados']"
                       data-placement="auto" title="Entregados">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Entregados</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center" data-toggle="tooltip"
                       [routerLink]="['mdo/pedidos/normales/post-venta/devueltos']"
                       data-placement="auto" title="Devueltos">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Devueltos</span>
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <!--<li class="nav-item {{menuToolbar['mdo']['param']}}">
            <a class="d-flex align-items-center" href="#/mdo/parametrizaciones/list" data-toggle="tooltip"
               data-placement="auto" title="Parametrizaciones MDO">
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Parametrización</span></a>
          </li>
          <li class="nav-item {{menuToolbar['mdo']['predCross']}}">
            <a class="d-flex align-items-center" href="#/mdo/predicciones/cross" data-toggle="tooltip"
               data-placement="auto" title="Predicciones para crosseling">
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Predicciones para crosseling</span></a>
          </li>
          <li class="nav-item {{menuToolbar['mdo']['predRefil']}}">
            <a class="d-flex align-items-center" href="#/mdo/predicciones/refil" data-toggle="tooltip"
               data-placement="auto" title="Predicciones para refil">
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Predicciones para refil</span></a>
          </li>
          <li class="nav-item {{menuToolbar['mdo']['predNueProd']}}">
            <a class="d-flex align-items-center" href="#/mdo/predicciones/nuevos" data-toggle="tooltip"
               data-placement="auto" title="Predicciones para nuevos productos">
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Predicciones para nuevos productos</span></a>
          </li>
          <li class="nav-item {{menuToolbar['mdo']['genOferta']}}">
            <a class="d-flex align-items-center" href="#/mdo/oferta/generar" data-toggle="tooltip"
               data-placement="auto" title="Generar oferta para cliente">
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Generar oferta para cliente</span></a>
          </li>-->
        </ul>
      </li>

      <li class="nav-item" *ngIf="acciones.MCT.LEER">
        <a class="d-flex align-items-center" title="MCT Motor de Cobro por Tarjeta">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">MCT Motor de Cobro por Tarjeta</span></a>
        <ul class="menu-content ng-star-inserted">
          <li class="nav-item">
            <a class="d-flex align-items-center" [routerLink]="['mct/parametrizaciones']" data-toggle="tooltip"
               data-placement="auto" title="Parametrizaciones">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Parametrizaciones</span></a>
          </li>
          <li class="nav-item">
            <a class="d-flex align-items-center" [routerLink]="['mct/generar/cobro']" data-toggle="tooltip"
               data-placement="auto" title="Realizar cobro">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Realizar cobro</span></a>
          </li>
          <li class="nav-item">
            <a class="d-flex align-items-center" [routerLink]="['mct/aprobacion/cobro/pedido']" data-toggle="tooltip"
               data-placement="auto" title="Aprobar cobro del pedido">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Aprobar cobro del pedido</span></a>
          </li>
          <li class="nav-item has-sub">
            <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
               title="Reporte pedidos">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Reporte pedidos</span></a>
            <ul class="menu-content">
              <li class="nav-item">
                <a class="d-flex align-items-center" data-toggle="tooltip"
                   [routerLink]="['mct/pedidos/cobro/aprobados']"
                   data-placement="auto" title="Aprobados">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Aprobados</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="d-flex align-items-center" data-toggle="tooltip"
                   [routerLink]="['mct/pedidos/cobro/no-aprobados']"
                   data-placement="auto" title="No aprobados">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">No aprobados</span>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </li>
      <li class="nav-item" *ngIf="acciones.MDC.LEER">
        <a class="d-flex align-items-center" title="MDC Motor de Comisiones">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">MDC Motor de Comisiones</span></a>
        <ul class="menu-content ng-star-inserted"
            *ngIf="usuario.usuario.idRol === 1 || (usuario.usuario.idRol === 80 || usuario.usuario.idRol === 84 || usuario.usuario.idRol === 87) || usuario.usuario.idRol === 84 || usuario.usuario.idRol === 87">
          <li class="nav-item">
            <a class="d-flex align-items-center" [routerLink]="['mdc/comision/reporte']" data-toggle="tooltip"
               data-placement="auto" title="Reporte de Comisiones">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Reporte de Comisiones</span></a>
          </li>
          <li class="nav-item has-sub" *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 80">
            <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
               title="Gestión de canje de premios">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Gestión de canje de premios</span></a>
            <ul class="menu-content ng-star-inserted">
              <li class="nav-item" *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 80">
                <a class="d-flex align-items-center" [routerLink]="['mdc/canjear-premios']" data-toggle="tooltip"
                   data-placement="auto" title="Canje de premios">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Canje de premios</span></a>
              </li>
              <li class="nav-item" *ngIf="usuario.usuario.idRol !== 80">
                <a class="d-flex align-items-center" [routerLink]="['mdc/despacho/canje-premios']" data-toggle="tooltip"
                   data-placement="auto" title="Despacho de premios">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Despacho de premios</span></a>
              </li>
              <li class="nav-item" *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 80">
                <a class="d-flex align-items-center" [routerLink]="['mdc/reporte/canje-premios']" data-toggle="tooltip"
                   data-placement="auto" title="Reporte de canje de premios">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Reporte de canje de premios</span></a>
              </li>
            </ul>
          </li>
        </ul>
      </li>
      <li class="nav-item" *ngIf="acciones.MCUM.LEER">
        <a class="d-flex align-items-center" title="MCUM Motor de Courier Ultima Milla">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">MCUM Motor de Courier Ultima Milla</span></a>
        <ul class="menu-content ng-star-inserted">
          <li class="nav-item">
            <a class="d-flex align-items-center" [routerLink]="['mcum/parametrizaciones']" data-toggle="tooltip"
               data-placement="auto" title="Parametrizaciones">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Parametrizaciones</span></a>
          </li>
          <li class="nav-item has-sub">
            <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
               title="Afiliación de Couriers">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Afiliación de Couriers</span></a>
            <ul class="menu-content">

              <li class="nav-item">
                <a class="d-flex align-items-center" data-toggle="tooltip"
                   [routerLink]="['mcum/courier/registrar']"
                   data-placement="auto" title="Registrar Couriers">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Registrar Couriers</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="d-flex align-items-center" data-toggle="tooltip"
                   [routerLink]="['mcum/courier/aprobar']"
                   data-placement="auto" title="Couriers aprobados">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Couriers aprobados</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="d-flex align-items-center" data-toggle="tooltip"
                   [routerLink]="['mcum/courier/lista']"
                   data-placement="auto" title="Couriers aprobados">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Couriers aprobados</span>
                </a>
              </li>
            </ul>
          </li>
          <li class="nav-item">
            <a class="d-flex align-items-center" [routerLink]="['mcum/configuracion-envio']" data-toggle="tooltip"
               data-placement="auto" title="Configuración de envío">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Configuración de envío</span></a>
          </li>
          <li class="nav-item">
            <a class="d-flex align-items-center" [routerLink]="['mcum/generar-guia']" data-toggle="tooltip"
               data-placement="auto" title="Generar guía">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Generar guía</span></a>
          </li>
        </ul>
      </li>
      <li class="nav-item"
          *ngIf="acciones.GD.LEER">
        <a class="d-flex align-items-center" title="GA Gestión de Asesores">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice" title="GA Gestión de Asesores">GA Gestión de Asesores</span></a>
        <ul class="menu-content ng-star-inserted">
          <li class="nav-item" *ngIf="usuario.usuario.idRol === 1">
            <a class="d-flex align-items-center" [routerLink]="['gd/gd_params']" data-toggle="tooltip"
               data-placement="auto" title="Parametrizaciones">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Parametrizaciones</span>
            </a>
          </li>
          <li class="nav-item has-sub ng-star-inserted"
              *ngIf="usuario.usuario.idRol === 1 || usuario.usuario.idRol === 61 || usuario.usuario.idRol === 65">
            <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
               title="Concretar ventas">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Concretar ventas</span></a>
            <ul class="menu-content">
              <li class="nav-item">
                <a class="d-flex align-items-center" [routerLink]="['gd/contacto/lista']" data-toggle="tooltip"
                   data-placement="auto" title="Listar Contactos">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Listar Contactos</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="d-flex align-items-center" [routerLink]="['gd/contacto/lista/reporte/venta']"
                   data-toggle="tooltip"
                   data-placement="auto" title="Reporte de contactos por ventas">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Reporte de contactos por ventas</span>
                </a>
              </li>
            </ul>
          </li>
          <li class="nav-item" *ngIf="usuario.usuario.idRol === 1">
            <a class="d-flex align-items-center" [routerLink]="['gd/gd_consulta_productos']" data-toggle="tooltip"
               data-placement="auto" title="Consulta de producto GD">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Consulta de productos</span>
            </a>
          </li>
          <li class="nav-item" *ngIf="usuario.usuario.idRol === 1">
            <a class="d-flex align-items-center" [routerLink]="['gd/asesor/emision/correos']" data-toggle="tooltip"
               data-placement="auto" title="Emisión de correos para asesores confirmados">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Emisión de correos para asesores confirmados</span>
            </a>
          </li>
          <!--<li class="nav-item"
              *ngIf="(usuario.usuario.idRol === 62 && usuario.usuario.canal === 'superbarato.megadescuento.com') || (usuario.usuario.idRol === 62 && usuario.usuario.canal === 'contraentrega.megadescuento.com') || usuario.usuario.idRol === 1 || usuario.usuario.idRol === 63">
            <a class="d-flex align-items-center" [routerLink]="['gd/pedido_woocommerce/crear']" data-toggle="tooltip"
               data-placement="auto" title="Generar Pedido Woocommerce">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Generar pedido woocommerce</span>
            </a>
          </li>-->
          <li class="nav-item has-sub ng-star-inserted"
              *ngIf="usuario.usuario.idRol === 1 || (usuario.usuario.idRol === 80 || usuario.usuario.idRol === 84 || usuario.usuario.idRol === 87)">
            <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
               title="Asesor/a comercial GLOBALEXITO y otros">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Asesor/a comercial GLOBALEXITO y otros</span></a>
            <ul class="menu-content">
              <li class="nav-item"
                  *ngIf="usuario.usuario.idRol !== 80 && usuario.usuario.idRol !== 84 && usuario.usuario.idRol !== 87"
              >
                <a class="d-flex align-items-center" [routerLink]="['gd/asesor/globalexito/resgistro']"
                   data-toggle="tooltip"
                   data-placement="auto" title="Registrar asesores comerciales">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Registrar asesores comerciales</span>
                </a>
              </li>
              <li class="nav-item"
                  *ngIf="usuario.usuario.idRol !== 80 && usuario.usuario.idRol !== 84 && usuario.usuario.idRol !== 87">
                <a class="d-flex align-items-center" [routerLink]="['gd/asesor/globalexito/list']" data-toggle="tooltip"
                   data-placement="auto" title="Asesores comerciales registrados">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Asesores comerciales registradoss</span>
                </a>
              </li>
              <li class="nav-item"
                  *ngIf="usuario.usuario.idRol !== 80 && usuario.usuario.idRol !== 84 && usuario.usuario.idRol !== 87">
                <a class="d-flex align-items-center"
                   [routerLink]="['gd/asesor/globalexito/configuracion/marketplace/asesor']"
                   data-toggle="tooltip"
                   data-placement="auto" title="Configurar marketplace de asesor">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Configurar marketplace de asesor</span>
                </a>
              </li>
              <li class="nav-item"
                  *ngIf="usuario.usuario.idRol !== 80 && usuario.usuario.idRol !== 84 && usuario.usuario.idRol !== 87">
                <a class="d-flex align-items-center" [routerLink]="['gd/asesor/globalexito/list/confirmados']"
                   data-toggle="tooltip"
                   data-placement="auto" title="Configurar Asesor@s Confirmados">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Configurar Asesor@s Confirmados</span>
                </a>
              </li>
              <!--<li class="nav-item" *ngIf="usuario.usuario.idRol !== 80 && usuario.usuario.idRol !== 84 && usuario.usuario.idRol !== 87">
                <a class="d-flex align-items-center" [routerLink]="['gd/asesor/globalexito/configuracion/formas-entrega']"
                   data-toggle="tooltip"
                   data-placement="auto" title="Configurar formas de entrega">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Configurar formas de entrega</span>
                </a>
              </li>-->
              <li class="nav-item has-sub">
                <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
                   title="Billetera digital">
                  <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                     data-i18n="List">Billetera digital</span></a>
                <ul class="menu-content">
                  <li class="nav-item">
                    <a class="d-flex align-items-center" data-toggle="tooltip"
                       [routerLink]="['gd/asesor/globalexito/billetera/digital/cargar_saldo']"
                       data-placement="auto" title="Cargar saldo billetera digital">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Cargar saldo billetera digital</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center" data-toggle="tooltip"
                       [routerLink]="['gd/asesor/globalexito/list/billetera/digital/movimientos']"
                       data-placement="auto" title="Movimientos billetera digital">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Movimientos billetera digital</span>
                    </a>
                  </li>
                </ul>
              </li>
              <li class="nav-item" *ngIf="usuario.usuario.idRol === 1">
                <a class="d-flex align-items-center" [routerLink]="['gd/reporte/pedidos/woocommerce']"
                   data-toggle="tooltip"
                   data-placement="auto" title="Pedidos desde Woocommerce">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Pedidos desde Woocommerce</span>
                </a>
              </li>
              <li class="nav-item" *ngIf="usuario.usuario.idRol === 1">
                <a class="d-flex align-items-center" [routerLink]="['gd/asesor/globalexito/reporte/asesor']"
                   data-toggle="tooltip"
                   data-placement="auto" title="Reporte asesor@s comerciales">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Reporte asesor@s comerciales</span>
                </a>
              </li>
            </ul>
          </li>
          <li class="nav-item has-sub ng-star-inserted" *ngIf="usuario.usuario.idRol === 1">
            <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
               title="Asesor/a comercial GLOBALPUNTO">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Asesor/a comercial GLOBALPUNTO</span></a>
            <ul class="menu-content">
              <li class="nav-item"
              >
                <a class="d-flex align-items-center" [routerLink]="['gd/asesor/globalpunto/resgistro']"
                   data-toggle="tooltip"
                   data-placement="auto" title="Registrar asesor@s comerciales">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Registrar asesor@s comerciales</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="d-flex align-items-center" [routerLink]="['gd/asesor/globalpunto/list']"
                   data-toggle="tooltip"
                   data-placement="auto" title="Asesor@s comerciales registrada">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Asesor@s comerciales registradas</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="d-flex align-items-center" [routerLink]="['gd/asesor/globalpunto/list/confirmados']"
                   data-toggle="tooltip"
                   data-placement="auto" title="Configurar Asesor@s Confirmados">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Configurar Asesor@s Confirmados</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="d-flex align-items-center"
                   [routerLink]="['gd/asesor/globalpunto/configuracion/formas-entrega']"
                   data-toggle="tooltip"
                   data-placement="auto" title="Configurar formas de entrega">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Configurar formas de entrega</span>
                </a>
              </li>
              <li class="nav-item has-sub">
                <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
                   title="Billetera digital">
                  <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                     data-i18n="List">Billetera digital</span></a>
                <ul class="menu-content">
                  <li class="nav-item">
                    <a class="d-flex align-items-center" data-toggle="tooltip"
                       [routerLink]="['gd/asesor/globalpunto/billetera/digital/cargar_saldo']"
                       data-placement="auto" title="Cargar saldo billetera digital">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Cargar saldo billetera digital</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center" data-toggle="tooltip"
                       [routerLink]="['gd/asesor/globalpunto/list/billetera/digital/movimientos']"
                       data-placement="auto" title="Movimientos billetera digital">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Movimientos billetera digital</span>
                    </a>
                  </li>
                </ul>
              </li>
              <li class="nav-item" *ngIf="usuario.usuario.idRol === 1">
                <a class="d-flex align-items-center" [routerLink]="['gd/reporte/pedidos/woocommerce']"
                   data-toggle="tooltip"
                   data-placement="auto" title="Pedidos desde Woocommerce">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Pedidos desde Woocommerce</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="d-flex align-items-center" [routerLink]="['gd/asesor/globalpunto/reporte/asesor']"
                   data-toggle="tooltip"
                   data-placement="auto" title="Reporte asesor@s comerciales">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Reporte asesor@s comerciales</span>
                </a>
              </li>
            </ul>
          </li>
          <li class="nav-item has-sub ng-star-inserted" *ngIf="usuario.usuario.idRol === 1">
            <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
               title="Asesor/a comercial CREDICOMPRA">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Asesor/a comercial CREDICOMPRA</span></a>
            <ul class="menu-content">
              <li class="nav-item"
              >
                <a class="d-flex align-items-center" [routerLink]="['gd/asesor/credicompra/resgistro']"
                   data-toggle="tooltip"
                   data-placement="auto" title="Registrar asesor@s comerciales">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Registrar asesor@s comerciales</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="d-flex align-items-center" [routerLink]="['gd/asesor/credicompra/list']" data-toggle="tooltip"
                   data-placement="auto" title="Asesor@s comerciales registrada">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Asesor@s comerciales registradas</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="d-flex align-items-center" [routerLink]="['gd/asesor/credicompra/list/confirmados']"
                   data-toggle="tooltip"
                   data-placement="auto" title="Configurar Asesor@s Confirmados">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Configurar Asesor@s Confirmados</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="d-flex align-items-center"
                   [routerLink]="['gd/asesor/credicompra/configuracion/formas-entrega']"
                   data-toggle="tooltip"
                   data-placement="auto" title="Configurar formas de entrega">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Configurar formas de entrega</span>
                </a>
              </li>
              <li class="nav-item has-sub">
                <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
                   title="Billetera digital">
                  <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                     data-i18n="List">Billetera digital</span></a>
                <ul class="menu-content">
                  <li class="nav-item">
                    <a class="d-flex align-items-center" data-toggle="tooltip"
                       [routerLink]="['gd/asesor/credicompra/billetera/digital/cargar_saldo']"
                       data-placement="auto" title="Cargar saldo billetera digital">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Cargar saldo billetera digital</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center" data-toggle="tooltip"
                       [routerLink]="['gd/asesor/credicompra/list/billetera/digital/movimientos']"
                       data-placement="auto" title="Movimientos billetera digital">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Movimientos billetera digital</span>
                    </a>
                  </li>
                </ul>
              </li>
              <li class="nav-item" *ngIf="usuario.usuario.idRol === 1">
                <a class="d-flex align-items-center" [routerLink]="['gd/reporte/pedidos/woocommerce']"
                   data-toggle="tooltip"
                   data-placement="auto" title="Pedidos desde Woocommerce">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Pedidos desde Woocommerce</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="d-flex align-items-center" [routerLink]="['gd/asesor/credicompra/reporte/asesor']"
                   data-toggle="tooltip"
                   data-placement="auto" title="Reporte asesor@s comerciales">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Reporte asesor@s comerciales</span>
                </a>
              </li>
            </ul>
          </li>
          <li class="nav-item has-sub ng-star-inserted" *ngIf="usuario.usuario.idRol === 1">
            <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
               title="Gestión Link Tree">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Gestión Link Tree</span></a>
            <ul class="menu-content">
              <li class="nav-item">
                <a class="d-flex align-items-center" [routerLink]="['gd/link-tree']" data-toggle="tooltip"
                   data-placement="auto" title="Creación Link Tree">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Creación Link Tree</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="d-flex align-items-center" [routerLink]="['gd/reporte/links-tree']" data-toggle="tooltip"
                   data-placement="auto" title="Reporte Link Tree">
                  <i data-feather="circle"></i>
                  <span class="menu-item text-truncate" data-i18n="List">Reporte Link Tree</span>
                </a>
              </li>
            </ul>
          </li>

        </ul>
      </li>
      <li class="ml-2"
          *ngIf="usuario.usuario.idRol !== 80 && usuario.usuario.idRol !== 84 && usuario.usuario.idRol !== 87 && (acciones.MDPC.LEER || acciones.MCT.LEER || acciones.MDC.LEER || acciones.MCUM.LEER || acciones.GD.LEER)">
        -------------------------------------
      </li>
      <li class="navigation-header"
          *ngIf="usuario.usuario.idRol !== 80 && usuario.usuario.idRol !== 84 && usuario.usuario.idRol !== 87 && acciones.MDM.LEER">
        ADMINISTRACION CLIENTES
      </li>

      <li class="nav-item" *ngIf="acciones.MDM.LEER">
        <a class="d-flex align-items-center collapsed_menu_item" title="MDM Master Data Managment">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">MDM Master Data Managment</span></a>
        <ul class="menu-content ng-star-inserted">
          <li class="nav-item {{menuToolbar['mdm']['param']}}">
            <a class="d-flex align-items-center" [routerLink]="['/mdm/parametrizaciones']" data-toggle="tooltip"
               data-placement="auto" title="Parametrizaciones MDM">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Parametrizaciones</span></a>
          </li>
          <li class="nav-item has-sub ng-star-inserted">
            <a class="d-flex align-items-center">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="Preview">Prospectos clientes</span></a>
            <ul class="menu-content">
              <li class="nav-item {{menuToolbar['mdm']['prospectosCli']}}">
                <a class="d-flex align-items-center" [routerLink]="['/mdm/prospectosClientes']"
                   data-toggle="tooltip"
                   data-placement="auto" title="Admin prospectos clientes">
                  <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Admin Prospectos Clientes</span></a>
              </li>
              <!-- <li class="nav-item {{menuToolbar['mdm']['addXLSX']}}">
                  <a class="d-flex align-items-center" href="#/mdm/prospectosClientes/addXLSX" data-toggle="tooltip" data-placement="right" title="Carga de prospectos XLSX">
                      <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="Preview">Carga de prospectos XLSX</span></a>
              </li>
              <li class="nav-item {{menuToolbar['mdm']['addCSV']}}">
                  <a class="d-flex align-items-center" href="#/mdm/prospectosClientes/addCSV" data-toggle="tooltip" data-placement="right" title="Carga de prospectos CSV">
                      <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="Edit">Carga de prospectos CSV</span></a>
              </li> -->
            </ul>
          </li>
          <li class="nav-item has-sub ng-star-inserted">
            <a class="d-flex align-items-center">
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="Preview">Clientes</span></a>
            <ul class="menu-content">
              <li class="nav-item has-sub ng-star-inserted">
                <a class="d-flex align-items-center">
                  <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                     data-i18n="List">Personas</span></a>
                <ul class="menu-content">
                  <li class="nav-item {{menuToolbar['mdm']['clientesList']}}">
                    <a class="d-flex align-items-center"
                       [routerLink]="['/mdm/clientes/personas/list']"
                       data-toggle="tooltip" data-placement="auto"
                       title="Administrar de los clientes">
                      <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                         data-i18n="List">Administración</span></a>
                  </li>
                  <li class="nav-item {{menuToolbar['mdm']['clientesTransac']}}">
                    <a class="d-flex align-items-center"
                       [routerLink]="['/mdm/clientes/personas/transacciones']"
                       data-toggle="tooltip" data-placement="auto" title="Transacciones de compra">
                      <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                         data-i18n="Preview">Transacciones de compra</span></a>
                  </li>
                  <li class="nav-item {{menuToolbar['mdm']['clientesTransacAdd']}}">
                    <a class="d-flex align-items-center"
                       [routerLink]="['/mdm/clientes/personas/transacciones/add']"
                       data-toggle="tooltip" data-placement="auto"
                       title="Generar transacciones de compra">
                      <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                         data-i18n="Edit">Generar transación</span></a>
                  </li>
                  <!-- <li class="nav-item {{menuToolbar['mdm']['clientesTransacLoad']}}">
                      <a class="d-flex align-items-center" href="#/mdm/clientes/personas/transacciones/load" data-toggle="tooltip" data-placement="right" title="Cargar transacciones CSV XLSX">
                          <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="Edit">Cargar transacciones</span></a>
                  </li> -->
                  <!-- <li class="nav-item {{menuToolbar['mdm']['clientesLoad']}}">
                      <a class="d-flex align-items-center" href="#/mdm/clientes/personas/load" data-toggle="tooltip" data-placement="right" title="Cargar datos de cliente CSV XLSX">
                          <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="Edit">Cargar datos de cliente</span></a>
                  </li> -->
                </ul>
              </li>

              <li class="nav-item has-sub ng-star-inserted">
                <a class="d-flex align-items-center" data-toggle="tooltip">
                  <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                     data-i18n="List">Negocios</span></a>
                <ul class="menu-content">
                  <li class="nav-item {{menuToolbar['mdm']['negociosList']}}">
                    <a class="d-flex align-items-center" href="#/mdm/clientes/negocios/list"
                       data-toggle="tooltip"
                       data-placement="auto" title="Administrar todos los negocios">
                      <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                         data-i18n="List">Administración</span></a>
                  </li>
                  <li class="nav-item {{menuToolbar['mdm']['negociosTransac']}}">
                    <a class="d-flex align-items-center"
                       href="#/mdm/clientes/negocios/transacciones/list"
                       data-toggle="tooltip" data-placement="auto" title="Transacciones de compra">
                      <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                         data-i18n="Preview">Transacciones de compra</span></a>
                  </li>
                  <li class="nav-item {{menuToolbar['mdm']['negociosTransacAdd']}}">
                    <a class="d-flex align-items-center"
                       href="#/mdm/clientes/negocios/transacciones/add"
                       data-toggle="tooltip" data-placement="auto"
                       title="Generar transacciones de compra">
                      <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                         data-i18n="Edit">Generar transación</span></a>
                  </li>
                  <!-- <li class="nav-item {{menuToolbar['mdm']['negociosTransacLoad']}}">
                      <a class="d-flex align-items-center" href="#/mdm/clientes/negocios/transacciones/load" data-toggle="tooltip" data-placement="right" title="Cargar transacciones CSV XLSX">
                          <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="Edit">Cargar transacciones</span></a>
                  </li>
                  <li class="nav-item {{menuToolbar['mdm']['negociosLoad']}}">
                      <a class="d-flex align-items-center" href="#/mdm/clientes/negocios/load" data-toggle="tooltip" data-placement="right" title="Cargar datos de negocios CSV XLSX">
                          <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="Edit">Cargar datos de cliente</span></a>
                  </li> -->
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </li>
      <li class="ml-2"
          *ngIf="usuario.usuario.idRol !== 80 && usuario.usuario.idRol !== 84 && usuario.usuario.idRol !== 87 && (acciones.MDM.LEER || acciones.MP.LEER || (acciones.GDE.LEER || acciones.GDE_EMPACADO.CREAR || acciones.GDE_DESPACHO.CREAR || usuario.usuario.idRol === 51) || (acciones.ADM.LEER && usuario.usuario.idRol !== 86) || acciones.GDP.LEER || acciones.GDC.LEER || acciones.GCN.LEER || acciones.GMB.LEER)">
        -------------------------------------
      </li>

      <li class="nav-item" *ngIf="acciones.MP.LEER">
        <a class="d-flex align-items-center" title="MP Motor de pedidos">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">MP Motor de pedidos</span></a>
        <ul class="menu-content">
          <li class="nav-item {{menuToolbar['mp']['param']}}" *ngIf="usuario.usuario.idRol !== 51">
            <a class="d-flex align-items-center" href="#/mp/parametrizaciones/list" data-toggle="tooltip"
               data-placement="auto" title="Parametrizaciones MP">
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Parametrización</span></a>
          </li>

          <li class="nav-item {{menuToolbar['mp']['pedidos']}}">
            <a class="d-flex align-items-center" href="#/mp/landing/list" data-toggle="tooltip"
               data-placement="auto" title="Pedidos Landing Vittoria">
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Pedidos Landing Vittoria</span></a>
          </li>
          <li class="nav-item {{menuToolbar['mp']['pedidos']}}">
            <a class="d-flex align-items-center" href="#/mp/pedidos-nuevos" data-toggle="tooltip"
               data-placement="auto" title="Pedidos Nuevos">
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Pedidos Nuevos</span></a>
          </li>
          <li class="nav-item {{menuToolbar['mp']['pedidos-devueltos']}}">
            <a class="d-flex align-items-center" href="#/mp/pedidos-devueltos" data-toggle="tooltip"
               data-placement="auto" title="Pedidos Devueltos">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Pedidos Devueltos</span></a>
          </li>
          <li class="nav-item {{menuToolbar['mp']['pedidos-rechazados']}}">
            <a class="d-flex align-items-center" href="#/mp/pedidos-rechazados" data-toggle="tooltip"
               data-placement="auto" title="Pedidos Rechazados">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Pedidos Rechazados</span></a>
          </li>
          <li class="nav-item has-sub ng-star-inserted">
            <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
               title="Pedidos por Canal">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Pedidos Canal</span></a>
            <ul class="menu-content">
              <li class="nav-item has-sub ng-star-inserted">
                <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
                   title="Woocomerce autogestión">
                  <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                     data-i18n="List">Woocomerce autogestión</span></a>
                <ul class="menu-content">
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['mp/pedido-canal/megabahia']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Pedido Canal Mega Bahia">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Pedido MegaBahia</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['mp/pedido-canal/mayorista']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Pedido Canal Mayorista">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Pedido Mayorista</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['mp/pedido-canal/megadescuento']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Pedido Canal Megadescuento">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Pedido Megadescuento</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['mp/pedido-canal/todomegacentro']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Pedido Canal TodoMegacentro">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Pedido TodoMegacentro</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['mp/pedido-canal/tiendamulticompras']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Pedido Canal TiendaMulticompras">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Pedido TiendaMulticompras</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['mp/pedido-canal/contraentrega']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Pedido Canal Contraentrega">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Pedido Contraentrega</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['mp/pedido-canal/maxidescuento']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Pedido Canal Maxidescuento">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Pedido Maxidescuento</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['mp/pedido-canal/vittoria']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Pedido Canal Vittoria">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Pedido Vittoria</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['mp/pedido-canal/superbarato']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Pedido Canal Superbarato">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Pedido Superbarato</span>
                    </a>
                  </li>
                </ul>
              </li>
              <li class="nav-item has-sub ng-star-inserted">
                <a class="d-flex align-items-center" data-toggle="tooltip" data-placement="auto"
                   title="Pedidos entrega local">
                  <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                     data-i18n="List">Pedidos entrega local</span></a>
                <ul class="menu-content">
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['mp/pedido-entrega-local/list']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Pedidos">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Pedidos</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="d-flex align-items-center" [routerLink]="['mp/pedido-entrega-local/entregados']"
                       data-toggle="tooltip"
                       data-placement="auto" title="Pedidos entregados">
                      <i data-feather="circle"></i>
                      <span class="menu-item text-truncate" data-i18n="List">Pedidos entregados</span>
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </li>
      <li class="nav-item"
          *ngIf="acciones.GDE.LEER || acciones.GDE_EMPACADO.CREAR || acciones.GDE_DESPACHO.CREAR || usuario.usuario.idRol === 51">
        <a class="d-flex align-items-center" title="GDE Gestión de entregas">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">GDE Gestión de entregas</span></a>
        <ul class="menu-content">
          <li *ngIf="acciones.GDE.CREAR" class="nav-item {{menuToolbar['gde']['param']}}">
            <a class="d-flex align-items-center" href="#/gde/parametrizaciones/list"
               title="Parametrizaciones de GDE"
            >
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Parametrización</span></a>
          </li>
          <li *ngIf="acciones.GDE.CREAR || acciones.GDE_EMPACADO.CREAR"
              class="nav-item {{menuToolbar['gde']['gestEntregaWoocommerceEmpacado']}}">
            <a class="d-flex align-items-center" href="#/gde/gestionEntrega/woocommerce/empacado" data-toggle="tooltip"
               data-placement="auto" title="Gestión de empacado">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Gestión de empacado</span></a>
          </li>
          <li *ngIf="acciones.GDE.CREAR || acciones.GDE_DESPACHO.CREAR || usuario.usuario.idRol === 51"
              class="nav-item {{menuToolbar['gde']['gestEntregaWoocommerceDespacho']}}">
            <a class="d-flex align-items-center" href="#/gde/gestionEntrega/woocommerce/despacho" data-toggle="tooltip"
               data-placement="auto" title="Gestión de despacho">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Gestión de despacho</span></a>
          </li>
          <li *ngIf="acciones.GDE.ESCRIBIR" class="nav-item {{menuToolbar['gde']['gestEntregaWoocommerceEnviado']}}">
            <a class="d-flex align-items-center" href="#/gde/gestionEntrega/woocommerce/enviado" data-toggle="tooltip"
               data-placement="auto" title="Gestión de enviado">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Gestión de enviado</span></a>
          </li>
          <li *ngIf="acciones.GDE.CREAR || usuario.usuario.idRol === 51"
              class="nav-item {{menuToolbar['gde']['gestEntregaWoocommerceDevolucion']}}">
            <a class="d-flex align-items-center" href="#/gde/gestionEntrega/woocommerce/devolucion-paquetes"
               data-toggle="tooltip"
               data-placement="auto" title="Reporte de devolución de paquetes">
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Reporte de devolución de paquetes</span></a>
          </li>
          <li *ngIf="acciones.GDE.CREAR" class="nav-item {{menuToolbar['gde']['reporteVentas']}}">
            <a class="d-flex align-items-center" href="#/gde/reportes"
               data-toggle="tooltip"
               data-placement="auto" title="Reporte de entregas">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Reporte de entregas</span></a>
          </li>
          <li *ngIf="usuario.usuario.idRol === 1">
            <a class="d-flex align-items-center" href="#/gde/reportes/pedidos"
               data-toggle="tooltip"
               data-placement="auto" title="Reporte de pedidos">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Reporte de pedidos</span></a>
          </li>
        </ul>
      </li>
      <li class="nav-item" *ngIf="acciones.ADM.LEER && usuario.usuario.idRol !== 86">
        <a class="d-flex align-items-center" title="GDB Gestión de bodega">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">GDB Gestión de bodega</span></a>
        <ul class="menu-content">
          <li class="nav-item">
            <a class="d-flex align-items-center" [routerLink]="['gdb/bodega']" data-toggle="tooltip"
               data-placement="auto" title="Bodega">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Bodega</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="d-flex align-items-center" [routerLink]="['gdb/pedidos']" data-toggle="tooltip"
               data-placement="auto" title="Vittoria">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Pedidos a bodega</span>
            </a>
          </li>
        </ul>
      </li>
      <li class="ml-2"
          *ngIf="usuario.usuario.idRol !== 80 && usuario.usuario.idRol !== 84 && usuario.usuario.idRol !== 87 && (acciones.MDM.LEER || acciones.MP.LEER || (acciones.GDE.LEER || acciones.GDE_EMPACADO.CREAR || acciones.GDE_DESPACHO.CREAR || usuario.usuario.idRol === 51) || (acciones.ADM.LEER && usuario.usuario.idRol !== 86) || acciones.GDP.LEER || acciones.GDC.LEER || acciones.GCN.LEER || acciones.GMB.LEER)">
        -------------------------------------
      </li>
      <li class="nav-item"
          *ngIf="acciones.GDP.LEER">
        <a class="d-flex align-items-center" title="GDP Gestión de pedidos">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">GDP Gestión de pedidos</span></a>
        <ul class="menu-content">

          <li class="nav-item">
            <a class="d-flex align-items-center" [routerLink]="['/gdp/pedidos']" data-toggle="tooltip"
               data-placement="auto" title="Generador de pedidos">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Generador de pedidos</span>
            </a>
          </li>
        </ul>
      </li>
      <li class="nav-item" *ngIf="acciones.GDC.LEER">
        <a class="d-flex align-items-center" title="GDC Gestión de contacto y venta">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">GDC Gestión de contacto y venta</span></a>
        <ul class="menu-content">
          <li class="nav-item">
            <a class="d-flex align-items-center" [routerLink]="['gdc/contacto']" data-toggle="tooltip"
               data-placement="auto" title="Contacto">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Despachar contactos</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="d-flex align-items-center" [routerLink]="['gdc/entregados']" data-toggle="tooltip"
               data-placement="auto" title="Despachos entregados">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Despachos entregados</span>
            </a>
          </li>
          <li class="nav-item" *ngIf="usuario.usuario.idRol === 1">
            <a class="d-flex align-items-center" [routerLink]="['gdc/facturas/cargadas']" data-toggle="tooltip"
               data-placement="auto" title="Confirmación de facturas cargadas">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Confirmación de facturas</span>
            </a>
          </li>
          <li class="nav-item" *ngIf="usuario.usuario.idRol === 1">
            <a class="d-flex align-items-center" [routerLink]="['gdc/facturas/quejas']" data-toggle="tooltip"
               data-placement="auto" title="Confirmación de quejas">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Confirmación de quejas</span>
            </a>
          </li>
        </ul>
      </li>
      <li class="nav-item" *ngIf="acciones.GCN.LEER">
        <a class="d-flex align-items-center" title="GCN Gestión de centro de negocios">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">GCN Gestión de centro de negocios</span></a>
        <ul class="menu-content">
          <li class="nav-item {{menuToolbar['gcn']['reporteVentasVendedor']}}">
            <a class="d-flex align-items-center" href="#/gcn/reporte-ventas-vendedor/list" data-toggle="tooltip"
               data-placement="auto" title="Reporte de ventas por contacto local">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Reporte de ventas por contacto local</span>
            </a>
          </li>
          <li class="nav-item {{menuToolbar['gcn']['reporteVentasVendedor']}}">
            <a class="d-flex align-items-center" href="#/gcn/reporte-ventas-vendedor-metodo-envio/list"
               data-toggle="tooltip"
               data-placement="auto" title="Reporte de ventas por método de envío">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Reporte de ventas por método de envío</span>
            </a>
          </li>
          <li
            class="nav-item {{menuToolbar['gcn']['reporteVentasVendedor']}}">
            <a class="d-flex align-items-center" href="#/gcn/reporte-ventas-centro-negocio/list" data-toggle="tooltip"
               data-placement="auto" title="Reporte de ventas del centro de negocio por contacto local">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Reporte de ventas del centro de negocio por contacto local</span>
            </a>
          </li>
          <li
            class="nav-item {{menuToolbar['gcn']['reporteVentasVendedor']}}">
            <a class="d-flex align-items-center" href="#/gcn/reporte-ventas-centro-negocio-metodo-envio/list"
               data-toggle="tooltip"
               data-placement="auto" title="Reporte de ventas del centro de negocio por método de envío">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Reporte de ventas del centro de negocio por método de envío</span>
            </a>
          </li>
        </ul>
      </li>
      <li class="nav-item" *ngIf="acciones.GMB.LEER">
        <a class="d-flex align-items-center" title="GMB Gestión de Despachos MEGABAHIA">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">GMB Gestión de Despachos MEGABAHIA</span></a>
        <ul class="menu-content">
          <li class="nav-item">
            <a class="d-flex align-items-center" [routerLink]="['gmb/megabahia']" data-toggle="tooltip"
               data-placement="auto" title="GMB Gestión de pedidos MEGABAHIA">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Generar pedido</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="d-flex align-items-center" [routerLink]="['gmb/entregados']" data-toggle="tooltip"
               data-placement="auto" title="Pedidos realizados">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Pedidos realizados</span>
            </a>
          </li>
        </ul>
      </li>

      <li class="ml-2"
          *ngIf="usuario.usuario.idRol !== 80 && usuario.usuario.idRol !== 84 && usuario.usuario.idRol !== 87 && usuario.usuario.idRol !== 89 && usuario.usuario.idRol !== 90 && (acciones.MDM.LEER || acciones.MP.LEER || (acciones.GDE.LEER || acciones.GDE_EMPACADO.CREAR || acciones.GDE_DESPACHO.CREAR || usuario.usuario.idRol === 51) || (acciones.ADM.LEER && usuario.usuario.idRol !== 86) || acciones.GDP.LEER || acciones.GDC.LEER || acciones.GCN.LEER || acciones.GMB.LEER)">
        -------------------------------------
      </li>

      <li class="navigation-header" style="color: #fbd304"
          *ngIf="usuario.usuario.idRol !== 80 && usuario.usuario.idRol !== 84 && usuario.usuario.idRol !== 87 && usuario.usuario.idRol !== 89 && usuario.usuario.idRol !== 90 && (acciones.MDO.LEER || acciones.GDO.LEER)">
        Módulos por afinar
      </li>
      <li class="nav-item" *ngIf="acciones.GDO.LEER">
        <a class="d-flex align-items-center">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">GDO Gestión de ofertas</span></a>
        <ul class="menu-content">
          <li class="nav-item {{menuToolbar['gdo']['param']}}">
            <a class="d-flex align-items-center" href="#/gdo/parametrizaciones/list"
               title="Parametrizaciones de GDO"
            >
              <i data-feather="circle"></i><span class="menu-item text-truncate" data-i18n="List">Parametrización</span></a>
          </li>
          <li class="nav-item {{menuToolbar['gdo']['gestOferta']}}">
            <a class="d-flex align-items-center" href="#/gdo/gestionOferta/list" data-toggle="tooltip"
               data-placement="auto" title="Gestión de la oferta">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Gestión de la oferta</span></a>
          </li>
        </ul>
      </li>
      <li class="ml-2"
          *ngIf="usuario.usuario.idRol !== 80 && usuario.usuario.idRol !== 84 && usuario.usuario.idRol !== 87 && usuario.usuario.idRol !== 89 && usuario.usuario.idRol !== 90 && (acciones.MDO.LEER || acciones.GDO.LEER)">
        -------------------------------------
      </li>
      <li class="navigation-header" style="color: #fbd304"
          *ngIf="usuario.usuario.idRol !== 80 && usuario.usuario.idRol !== 84 && usuario.usuario.idRol !== 87 && acciones.SERVI.LEER">
        Módulos de servientrega
      </li>
      <li class="nav-item" *ngIf="acciones.SERVI.LEER">
        <a class="d-flex align-items-center">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">Servientrega</span></a>
        <ul class="menu-content">
          <li class="nav-item {{menuToolbar['servi']['ciudades']}}">
            <a class="d-flex align-items-center" href="#/servientrega/ciudades" data-toggle="tooltip"
               data-placement="auto" title="Ciudades">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Ciudades</span></a>
          </li>
          <li class="nav-item {{menuToolbar['servi']['guias']}}">
            <a class="d-flex align-items-center" href="#/servientrega/guias/crear" data-toggle="tooltip"
               data-placement="auto" title="Generación de guías">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Generación de guías</span></a>
          </li>
          <li class="nav-item {{menuToolbar['servi']['guias']}}">
            <a class="d-flex align-items-center" href="#/servientrega/guias/retorno" data-toggle="tooltip"
               data-placement="auto" title="Generación de guías de retorno">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Generación de guías de retorno</span></a>
          </li>
          <li class="nav-item {{menuToolbar['servi']['guias']}}">
            <a class="d-flex align-items-center" href="#/servientrega/guias/recaudo" data-toggle="tooltip"
               data-placement="auto" title="Generación de guías de recaudo">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Generación de guías de recaudo</span></a>
          </li>
          <li class="nav-item {{menuToolbar['servi']['guias']}}">
            <a class="d-flex align-items-center" href="#/servientrega/guias/pdf-a4" data-toggle="tooltip"
               data-placement="auto" title="Generación de guías de PDF A4">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Generación de guías de PDF A4</span></a>
          </li>
          <li class="nav-item {{menuToolbar['servi']['guias']}}">
            <a class="d-flex align-items-center" href="#/servientrega/guias/digital-pdf"
               data-toggle="tooltip"
               data-placement="auto" title="Generación de guías digital PDF">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Generación de guías digital PDF</span></a>
          </li>
          <li class="nav-item {{menuToolbar['servi']['guias']}}">
            <a class="d-flex align-items-center" href="#/servientrega/guias/sticker" data-toggle="tooltip"
               data-placement="auto" title="Generación de guías formato Sticker">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Generación de guías formato Sticker</span></a>
          </li>
          <li class="nav-item {{menuToolbar['servi']['guias']}}">
            <a class="d-flex align-items-center" href="#/servientrega/guias/manifiesto-pdf"
               data-toggle="tooltip"
               data-placement="auto" title="Generación de manifiesto PDF">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Generación de manifiesto PDF</span></a>
          </li>
          <li class="nav-item {{menuToolbar['servi']['guias']}}">
            <a class="d-flex align-items-center" href="#/servientrega/guias/rotulos-formato-pdf"
               data-toggle="tooltip"
               data-placement="auto" title="Generación de Rotulos formato PDF">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Generación de Rotulos formato PDF</span></a>
          </li>
        </ul>
      </li>
      <li class="navigation-header" style="color: #fbd304"
          *ngIf="usuario.usuario.idRol !== 80 && usuario.usuario.idRol !== 84 && usuario.usuario.idRol !== 87 && acciones.FACTURACION.LEER">
        Facturación Electrónica
      </li>
      <li class="nav-item" *ngIf="acciones.FACTURACION.LEER">
        <a class="d-flex align-items-center" title="Configuración para facturación">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">Configuración para facturación</span></a>
        <ul class="menu-content">
          <li class="nav-item">
            <a class="d-flex align-items-center" href="#/facturacion/parametrizaciones" data-toggle="tooltip"
               data-placement="auto" title="Parametrizaciones">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Parametrizaciones</span></a>
          </li>
          <li class="nav-item">
            <a class="d-flex align-items-center" href="#/facturacion/configuracion/sri" data-toggle="tooltip"
               data-placement="auto" title="Configuración de datos para SRI">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Configuración de datos para SRI</span></a>
          </li>
        </ul>
      </li>
      <li class="nav-item" *ngIf="acciones.FACTURACION.LEER">
        <a class="d-flex align-items-center">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">Facturación Globaléxito</span></a>
        <ul class="menu-content">
          <li class="nav-item {{menuToolbar['facturacion']['locales']}}">
            <a class="d-flex align-items-center" href="#/facturacion/canal-vittoria/pendiente" data-toggle="tooltip"
               data-placement="auto" title="Pendiente">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Pendiente</span>
            </a>
          </li>
          <li class="nav-item {{menuToolbar['facturacion']['externas']}}">
            <a class="d-flex align-items-center" href="#/facturacion/canal-vittoria/facturadas" data-toggle="tooltip"
               data-placement="auto" title="Factura Electronica">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Factura Electronica</span></a>
          </li>
        </ul>
      </li>
      <li class="nav-item" *ngIf="acciones.FACTURACION.LEER">
        <a class="d-flex align-items-center">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">Canal Externas</span></a>
        <ul class="menu-content">
          <li class="nav-item {{menuToolbar['facturacion']['locales']}}">
            <a class="d-flex align-items-center" href="#/facturacion/canal-externas/pendiente" data-toggle="tooltip"
               data-placement="auto" title="Pendiente">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Pendientes</span>
            </a>
          </li>
          <li class="nav-item {{menuToolbar['facturacion']['externas']}}">
            <a class="d-flex align-items-center" href="#/facturacion/canal-externas/facturadas" data-toggle="tooltip"
               data-placement="auto" title="Factura Electronica">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Factura Electronica</span></a>
          </li>
        </ul>
      </li>
      <li class="nav-item" *ngIf="acciones.FACTURACION.LEER">
        <a class="d-flex align-items-center">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">Canal Woocommerce</span></a>
        <ul class="menu-content">
          <li class="nav-item {{menuToolbar['facturacion']['locales']}}">
            <a class="d-flex align-items-center" href="#/facturacion/canal-woocommerce/pendiente" data-toggle="tooltip"
               data-placement="auto" title="Pendientes">
              <i data-feather="circle"></i>
              <span class="menu-item text-truncate" data-i18n="List">Pendientes</span>
            </a>
          </li>
          <!--                    <li class="nav-item {{menuToolbar['facturacion']['externas']}}">-->
          <!--                        <a class="d-flex align-items-center" href="#/facturacion/canal-woocommerce/facturadas">-->
          <!--                            <i data-feather="circle"></i>-->
          <!--                            <span class="menu-item text-truncate" data-i18n="List">Factura electronica</span></a>-->
          <!--                    </li>-->
        </ul>
      </li>
      <li class="navigation-header" style="color: #fbd304"
          *ngIf="usuario.usuario.idRol !== 80 && usuario.usuario.idRol !== 84 && usuario.usuario.idRol !== 87 && acciones.REPORTES.LEER">
        Reportes
      </li>
      <li class="nav-item" *ngIf="acciones.REPORTES.LEER">
        <a class="d-flex align-items-center">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">Reportes</span></a>
        <ul class="menu-content">
          <li class="nav-item {{menuToolbar['reportes']['productos']}}">
            <a class="d-flex align-items-center" [routerLink]="['/reportes/productos']" data-toggle="tooltip"
               data-placement="auto" title="Reporte Productos Comprados">
              <i data-feather="list"></i>
              <span class="menu-title text-truncate" data-i18n="List">Reporte Productos Comprados</span>
            </a>
          </li>
          <li class="nav-item {{menuToolbar['reportes']['clientes']}}">
            <a class="d-flex align-items-center" [routerLink]="['/reportes/clientes']" data-toggle="tooltip"
               data-placement="auto" title="Reporte Clientes Compras">
              <i data-feather="list"></i>
              <span class="menu-title text-truncate" data-i18n="List">Reporte Clientes Compras</span>
            </a>
          </li>
        </ul>
      </li>
      <!--<li class="navigation-header">Todomegacentro</li>
      <li class="nav-item" *ngIf="acciones.TODOMEGA.LEER">
        <a class="d-flex align-items-center">
          <i data-feather="file-text"></i>
          <span class="menu-title text-truncate" data-i18n="Invoice">mega centro</span></a>
        <ul class="menu-content">
          <li class="nav-item {{menuToolbar['todomegacentro']['inicio']}}">
            <a class="d-flex align-items-center" href="#/todomegacentro/inicio" data-toggle="tooltip"
               data-placement="auto" title="Inicio">
              <i data-feather="circle"></i><span class="menu-item text-truncate"
                                                 data-i18n="List">Inicio</span></a>
          </li>
        </ul>
      </li>-->
      <li class="ml-2"
          *ngIf="usuario.usuario.idRol !== 80 && usuario.usuario.idRol !== 84 && usuario.usuario.idRol !== 87 && (acciones.SERVI.LEER || acciones.FACTURACION.LEER || acciones.REPORTES.LEER)">
        -------------------------------------
      </li>
    </ul>
  </div>
</div>
